/*
document.addEventListener('unload', () => {
	confirm('Deseja fechar a página?');
	
	e.preventDefault();
	e.returnValue = '';
	delete e['returnValue'];
})
*/

var LISTA_METODOS_RECOGNIZER = [];

var msgBeforeunload = 0;
var ativarKeyEventRefresh = true;

function isNumeric(str) {
	if (typeof str != "string") return false
	return !isNaN(str) &&
		!isNaN(parseFloat(str))
}

window.addEventListener('beforeunload', function (e) {
	//console.log(e);

	if (msgBeforeunload == 1) {

		if (ativarKeyEventRefresh == true) {
			msgBeforeunload = 0;
		}

		e.preventDefault();
		e.returnValue = msgBeforeunload;
		delete e['returnValue'];
	} else {

	}
});

function localStorageSpace() {
	var allStrings = '';
	for (var key in window.localStorage) {
		if (window.localStorage.hasOwnProperty(key)) {
			allStrings += window.localStorage[key];
		}
	}

	return allStrings ? 3 + ((allStrings.length * 16) / (8 * 1024)) : 0;
};

function localStorageInsert(hash, dados) {

	try {

		localStorageClear();

		localStorage.setItem(hash, JSON.stringify(dados));

	} catch (error) {
		//localStorageClear();	
	}

}

function FN_INT_ROUND_UP(valor) {
    var diferenca = valor - Math.round(valor);

    if (diferenca > 0) {
        valor = Math.round(valor + 0.5);
    } else {
        valor = Math.round(valor);
    }

    return valor;
}

function localStorageClear() {

	for (var key in window.localStorage) {
		/*
		if(
			window.localStorage.hasOwnProperty(key) &&
			'ngStorage-menus'  !=  key &&
			'ngStorage-grupos' !=  key &&
			('##'+key).indexOf('12200_TBPEDIDO') <= 0
		){
			localStorage.removeItem(key);
		}*/

		if (
			window.localStorage.hasOwnProperty(key)
		) {
			var cache = localStorage.getItem(key);
			cache = JSON.parse(cache);

			try {
				var timeDateHora = new Date();
				timeDateHora = timeDateHora.addDays(-1);

				if (typeof cache.DATA_EXPIRAR != 'undefined') {
					if (cache.DATA_EXPIRAR <= timeDateHora) {
						localStorage.removeItem(key);
					}
				} else {
					var pos = ('' + key).indexOf('cache');
					var dat = moment(cache.DATA).toDate();
					dat = dat <= timeDateHora;

					if (pos == 0 && typeof cache.DATA != 'undefined' && dat) {
						localStorage.removeItem(key);
					}
				}
			} catch (error) { }
		}
	}

	return true;
};

const areArraysOfObjectsEqual  = (arr1, arr2) => JSON.stringify(arr1) === JSON.stringify(arr2);

// Retorna boolean true se JSON vazio
function isJSONEmpty(obj) {
	for (var prop in obj) {
		if (obj.hasOwnProperty(prop)) {
			return false;
		}
	}

	return JSON.stringify(obj) === JSON.stringify({});
}

function isEquivalentObj(a, b, ignore, colunas) {
	// Create arrays of property names
	var aProps = Object.getOwnPropertyNames(a);
	var bProps = Object.getOwnPropertyNames(b);

	if (typeof colunas != 'undefined') {
		aProps = colunas;
		bProps = colunas;
	}

	if (typeof ignore != 'undefined') {
		var tmp_aProps = [];
		var tmp_bProps = [];

		for (var i = 0; i < aProps.length; i++) {
			var propName = aProps[i];
			var ignorar = false;

			for (var j = 0; j < ignore.length; j++) {
				var pName = ignore[j];

				if (pName == propName) {
					ignorar = true;
				}

			}

			if (!ignorar) {
				tmp_aProps.push(propName);
			}

		}

		for (var i = 0; i < bProps.length; i++) {
			var propName = bProps[i];
			var ignorar = false;

			for (var j = 0; j < ignore.length; j++) {
				var pName = ignore[j];

				if (pName == propName) {
					ignorar = true;
				}

			}

			if (!ignorar) {
				tmp_bProps.push(propName);
			}

		}

		aProps = tmp_aProps;
		bProps = tmp_bProps;

	}

	// If number of properties is different,
	// objects are not equivalent
	if (aProps.length != bProps.length) {
		return false;
	}

	for (var i = 0; i < aProps.length; i++) {
		var propName = aProps[i];

		// If values of same property are not equal,
		// objects are not equivalent
		if (a[propName] !== b[propName]) {
			return false;
		}
	}

	// If we made it this far, objects
	// are considered equivalent
	return true;
}

function isEquivalentArray(a, b, ignore, colunas) {

	if (a.length != b.length) {
		return false;
	}

	for (var index = 0; index < a.length; index++) {
		var item1 = a[index];
		var item2 = b[index];

		if (!isEquivalentObj(item1, item2, ignore, colunas)) {
			return false;
		}
	}

	return true;
}

function compareArraysByProp(arr1, arr2, prop) {
	if (arr1.length !== arr2.length) {
	  return false; // Arrays must have the same length for comparison
	}
  
	for (let i = 0; i < arr1.length; i++) {
	  if (arr1[i][prop] !== arr2[i][prop]) {
		return false; // Property value mismatch for at least one pair of objects
	  }
	}
  
	return true; // All property values match for corresponding objects in both arrays
}

function somar(number1, number2) {
	number1 = numeral(Number(number1));
	number2 = numeral(Number(number2));
	return number1.add(number2.value()).value();
}

function subtrair(number1, number2) {
	number1 = numeral(Number(number1));
	number2 = numeral(Number(number2));
	return number1.subtract(number2.value()).value();
}

function dividir(number1, number2) {
	number1 = numeral(Number(number1));
	number2 = numeral(Number(number2));
	return number1.divide(number2.value()).value();
}

function multiplicar(number1, number2) {
	number1 = numeral(Number(number1));
	number2 = numeral(Number(number2));
	return number1.multiply(number2.value()).value();
}

$(function () {
	$(document).on("keydown", function (e) {
		if (e.which === 116 && ativarKeyEventRefresh == true) {
			msgBeforeunload = 1;
		}
	});
});

function ativarBeforeunload(flag) {
	if (flag == 1) {
		msgBeforeunload = 1;
	}
}

function desativarBeforeunload(flag) {
	if (flag == 1) {
		msgBeforeunload = 0;
	}
}

function applyIEMaskFn(value, uf) {
	var mask = getMaskIE(uf, value);

	if (!mask) {
		return value;
	}

	var processed = mask.process(clearValueIE(value));
	var formatedValue = processed.result || '';
	formatedValue = formatedValue.trim().replace(/[^0-9]$/, '');

	if (uf === 'SP' && /^p/i.test(value)) {
		return 'P' + formatedValue;
	}

	return formatedValue;
}

function getMaskIE(uf, value) {
	if (!uf || !ieMasks[uf]) {
		return;
	}

	if (uf === 'SP' && /^P/i.test(value)) {
		return ieMasks.SP[1].mask;
	}

	var masks = ieMasks[uf];
	var i = 0;

	for (var index = 0; index < masks.length; index++) {
		var element = masks[index];

		if (trim_null(element.chars) != '') {
			if (element.chars == clearValueIE(value).length) {
				i++;
				break;
			}
		} else {

		}

	}
	// while (masks[i].chars && masks[i].chars < clearValueIE(value).length && i < masks.length - 1) {
	// 	i++;
	// }

	return masks[i].mask;
}

function RangeNumber(start, end) {
	var array = [];
	var count = start;
	if (start == end) {
		array.push(count);
	} else {
		for (var i = 0; i < (end - start) + 1; i++) {
			if (i > 0) {
				count = count + 1;
			}
			array.push(count);
		}
	}
	return array;
}

function clearValueIE(value) {
	if (!value) {
		return value;
	}

	return value.replace(/[^0-9]/g, '');
}

function validatorIE(ie, state) {
	var BrV = require('br-validations');

	return BrV.ie(state).validate(ie);
}

function gerarChave(flag, tamanho, usa_simbolo) {

	var lista = '';
	var lista1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123567894';//62
	var lista2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123567894=@#$%¨&*()_-+!{}[]'; //80

	if (usa_simbolo == true) {
		lista = lista2;
		var posicoes = 78;
	} else {
		lista = lista1;
		var posicoes = 61;
	}

	var codigo = flag + '';
	for (var i = 0; i <= tamanho; i++) {
		var pos = Math.random() * (posicoes - 0) + 0;
		codigo = codigo + lista.substring(pos, pos + 1)
	}

	return codigo;
}

function VerificarCPF(strCPF, ColabPadrao) {
	var Soma;
	var Resto;
	Soma = 0;

	var array = ['00000000000',
		'11111111111',
		'99999999999',
		'00000000000000',
		'11111111111111',
		'99999999999999']

	if (array.indexOf(strCPF) !== -1) {
		if (ColabPadrao == true) {
			return true;
		} else {
			return false;
		}
	}

	for (var i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
	Resto = (Soma * 10) % 11;

	if ((Resto == 10) || (Resto == 11)) {
		Resto = 0;
	}

	if (Resto != parseInt(strCPF.substring(9, 10))) {
		//console.log('inválido');
		return false;
	}

	Soma = 0;
	for (var i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
	Resto = (Soma * 10) % 11;

	if ((Resto == 10) || (Resto == 11)) {
		Resto = 0;
	}

	if (Resto != parseInt(strCPF.substring(10, 11))) {
		//console.log('inválido');
		return false;
	}
	//console.log('válido');
	return true;

}


function encode_utf8(s) {
	return unescape(encodeURIComponent(s));
}

function toUTF8(s) {
	return decodeURIComponent(escape(s));
}

function array_is_identical(array, prop) {
	//Se for array unidimensional
	if (typeof prop == 'undefined') {
		for (var i = 0; i < array.length - 1; i++) {
			if (array[i] !== array[i + 1]) {
				return false;
			}
		}
	} else {
		//Se for array de objetos
		for (var i = 0; i < array.length - 1; i++) {
			if (array[i][prop] !== array[i + 1][prop]) {
				return false;
			}
		}
	}

	return true;
}

//Ordenar array de objetos por valor de uma propriedade em ordem crecente
function sort_by_key(array, key) {
	return array.sort(function (a, b) {
		var x = a[key]; var y = b[key];
		return ((x < y) ? -1 : ((x > y) ? 1 : 0));
	});
}

//Ordenar array de objetos por valor de uma propriedade em ordem decresente
function sort_by_key_desc(array, key) {
	return array.sort(function (a, b) {
		var x = a[key]; var y = b[key];
		return ((x > y) ? -1 : ((x < y) ? 1 : 0));
	});
}

function sort_array(array) {
	return array.sort(function (a, b) {
		var x = a; var y = b;
		return ((x < y) ? -1 : ((x > y) ? 1 : 0));
	});
}

function truncateString(str, n) {
	return (str.length > n) ? str.substr(0, n - 1) + '&hellip;' : str;
};

function setFocusInputTela(modal) {
	var firstInput = $(modal).find('input,select,textarea,div[contenteditable=true]').not('.not_tab_enter').filter(":visible:first");
	firstInput.focus();
}

function isValidURL(string) {
	var res = string.match(/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
	return (res !== null)
};

function mmc(o) {
	for (var i, j, n, d, r = 1; (n = o.pop()) != undefined;)
		while (n > 1) {
			if (n % 2) {
				for (i = 3, j = Math.floor(Math.sqrt(n)); i <= j && n % i; i += 2);
				d = i <= j ? i : n;
			}
			else
				d = 2;
			for (n /= d, r *= d, i = o.length; i; !(o[--i] % d) && (o[i] /= d) == 1 && o.splice(i, 1));
		}
	return r;
}

function fmdc(a, b) {
	while (b != 0) {
		var r = a % b;
		a = b;
		b = r;
	}
	return a;
}

function mdc(numberList) {
	var mdcResultado = numberList[0];
	for (var i = 1; i < numberList.length; i++) {
		mdcResultado = fmdc(mdcResultado, numberList[i]);
	}
	return mdcResultado;
}

function isURL1(str) {
	var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
		'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
		'(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
	return pattern.test(str);
}

function isURL2(str) {
	var pattern = new RegExp('((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
		'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
		'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
		'(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
	return pattern.test(str);
}

var timeZone = '';
var locale = '';

function getTimeZone() {

	var tz = Intl.DateTimeFormat().resolvedOptions();
	timeZone = tz.timeZone;
	locale = tz.locale;

	//console.log(tz);

	if ('America/Sao_Paulo' != timeZone && 'America/Fortaleza' != timeZone && 'America/Belem' != timeZone) {
		//showErro("Seu navegador está com 'Time Zone' para '"+timeZone+"', para usar o GCWeb ele deve ser 'America/Sao_Paulo', 'America/Fortaleza' ou 'America/Belem'");
	}

	if (locale != 'pt-BR') {
		showErro("Seu navegador está com 'locale' para '" + locale + "', para usar o GCWeb ele deve ser 'pt-BR'");
	}

}

/*
$(document).keydown(function(e) {

	// Set self as the current item in focus
	var self = $(':focus'),
		// Set the form by the current item in focus
		form = self.parents('form:eq(0)'),
		focusable;
  
	// Array of Indexable/Tab-able items
	//focusable = form.find('input,a,select,button,textarea,div[contenteditable=true]').filter(':visible');
	focusable = form.find('input,select,textarea,div[contenteditable=true]').not('.not_tab_enter').filter(':visible');
  
	function enterKey(){
	  if (e.which === 13 && !self.is('textarea,div[contenteditable=true]')) { // [Enter] key
  
		// If not a regular hyperlink/button/textarea
		if ($.inArray(self, focusable) && (!self.is('a,button'))){
		  // Then prevent the default [Enter] key behaviour from submitting the form
		  e.preventDefault();
		} // Otherwise follow the link/button as by design, or put new line in textarea
  
		// Focus on the next item (either previous or next depending on shift)
		focusable.eq(focusable.index(self) + (e.shiftKey ? -1 : 1)).focus();
  
		return false;
	  }
	}
    
	// We need to capture the [Shift] key and check the [Enter] key either way.
	if (e.shiftKey) { enterKey() } else { enterKey() }

});
*/

/**
 * Remove de uma string caracteres especiais e espaços e os substitui por respectivas letras e _
 * 
 * @param {string} string String de origem para substituir os valores
 * @returns {string} String de retorno sem os caracteres
 */
function removeCaracteresEspeciais(string) {
    // Substitui caracteres especiais por letras que os representam
    string = string.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[áàãâä]/g, 'a').replace(/[éèêë]/g, 'e').replace(/[íìîï]/g, 'i').replace(/[óòõôö]/g, 'o').replace(/[úùûü]/g, 'u').replace(/[ç]/g, 'c');

    // Substitui espaços por _
    string = string.replace(/\s+/g, '_');

    return string;
}


/**
 * Separa uma string de acordo com a quantidade de caracteres informada e retorna um array com os valores separados
 * 
 * Exemplo:
 * var string = 'Essa é uma string de teste para a função';
 * spliter(string, 5) = ["Essa ", "é uma", " stri", "ng de", " test", "e par", "a a f", "unção"];
 * 
 * @param {string} str String que será quebrada pela função
 * @param {integer} tam Tamanho de cada linha quando ela formar
 * @returns {array} Array das linhas quebradas
 */
function spliter(str, tam) {
	var parts = [];

	for (let i = 0, length = str.length; i < length; i += tam) {
		parts.push(str.substring(i, i + tam));
	}

	return parts;
}

/**
 * Retorna um array após fazer split com a string enviada
 * exemplo: 
 * var a = '1,2;3';
 * splitMulti(a,[',',';']) = ['1','2','3']; 
 */
function splitMulti(str, tokens) {
	var tempChar = tokens[0];
	for (var i = 1; i < tokens.length; i++) {
		str = str.split(tokens[i]).join(tempChar);
	}
	str = str.split(tempChar);
	return str;
}

/**
 * Retorna um array ao converter o objeto (array-like) a ser iterado
 */
function arrayMuttie(objeto) {
	var coluns = Object.keys(objeto);
	var array_return = [];
	for (var a = 0; a < coluns.length; a++) {
		array_return.push(objeto[coluns[a]]);
	}
	return array_return;
}

/**
 * Retorna true se acaso a string recebida(email) for válido
 * Retorna falso se não.
 */
function IsEmail(email) {
	var exclude = /[^@\-\.\w]|^[_@\.\-]|[\._\-]{2}|[@\.]{2}|(@)[^@]*\1/;
	var check = /@[\w\-]+\./;
	var checkend = /\.[a-zA-Z]{2,3}$/;
	if (((email.search(exclude) != -1) || (email.search(check)) == -1) || (email.search(checkend) == -1)) { return false; }
	else { return true; }
}

/**
 * Retorna um lpad do valor(dado) no tamanho (tam) enviado
 */
function strzero(dado, tam) {
	var varTemp = dado;
	for (i = varTemp.length; i < tam; i++)
		varTemp = "0" + varTemp;
	return varTemp;
}
/**
 * Retorna um lpad do valor(dado) no tamanho (tam) enviado
 * o valor será convertido para uma string antes de ser mascarado
 */
function strzero2(dado, tam) {
	var varTemp = trim_null(dado);
	for (i = varTemp.length; i < tam; i++)
		varTemp = "0" + varTemp;
	return varTemp;
}
/**
 * Retorna um lpad(tipo = 'l') ou rpad (tipo = 'r') do valor(dado) no tamanho (tam) enviado
 * o valor será convertido para uma string antes de ser mascarado com o caracter(mask)
 */
function strzero3(dado, tam, mask, tipo) {
	if (typeof tipo == 'undefined') {
		tipo = 'l';
	}

	if (typeof mask == 'undefined') {
		mask = '0';
	}
	var varTemp = trim_null(dado);
	for (i = varTemp.length; i < tam; i++) {
		if (tipo == 'l') {
			varTemp = mask + varTemp;
		} else {
			varTemp = varTemp + mask;
		}
	}
	return varTemp;
}

/**
 * Retorna a posição no array (array) de objetos de um objeto de valores (value) na propriedade (prop) 
 * Retorna -1 se não encontrar
 */
function findInArrayByManyProps(array, value) {
	var u = -1;
	var variables = Object.keys(value);
	var variables2 = [];
	var counter_zyx = 0;
	for (var xyz = 0; xyz < variables.length; xyz++) {
		var chars = {};
		chars[variables[xyz]] = value[variables[xyz]];
		chars['NAME'] = variables[xyz];
		chars['found'] = false;
		variables2.push(chars);
	}
	//console.log('agrupamento de variáveis:',variables2);
	for (var i = 0; i < array.length; i++) {
		counter_zyx = 0;
		for (var a = 0; a < variables2.length; a++) {
			//console.log('valor:',variables2[a][variables2[a]['NAME']]);
			if (array[i][variables2[a]['NAME']] == variables2[a][variables2[a]['NAME']]) {
				counter_zyx++;
			}
		}
		if (counter_zyx == variables2.length) {
			u = i;
			break;
		}
	}
	return u;
};

/**
 * Retorna a posição no array (array) de objetos de um valor (value) na propriedade (prop) 
 * Retorna -1 se não encontrar
 */
function findInArrayByProp(array, prop, value, ignore_index = []) {
	var u = -1;
	for (var i = 0; i < array.length; i++) {
		if (array[i][prop] == value && ignore_index.indexOf(i) == -1) {
			u = i;
			break;
		}
	}

	return u;
};

/**
 * Retorna se o array de objetos possui uma propriedade especificada
 * Retorna -1 se não encontrar
 */
function findInArrayProp(array, prop) {
	var u = -1;
	for (var i = 0; i < array.length; i++) {
		if (typeof array[i][prop] != 'undefined') {
			u = i;
			break;
		}
	}

	return u;
};
/**
 * Retorna se o array unidimensional possui um valor especificado
 * Retorna -1 se não encontrar
 */
function findInArrayUnid(array, valor) {
	var u = -1;
	for (var i = 0; i < array.length; i++) {
		if (array[i] == valor) {
			u = i;
			break;
		}
	}

	return u;
};

/**
 * Retorna o array separado em quantas quantidades forem declaradas
 */
function ArrayPartitioner(arr, len) {

	var chunks = [],
		i = 0,
		n = arr.length;

	if (arr.length < len) {
		chunks = arr;
	} else {
		while (i < n) {
			chunks.push(arr.slice(i, i += len));
		}
	}

	return chunks;
}

/**
 * Remove registros duplicados de um array
 * filtrando o array "a"
 */
function removeDupesInArrayUni(a) {
	var seen = {};
	var out = [];
	var len = a.length;
	var j = 0;
	for (var i = 0; i < len; i++) {
		var item = a[i];
		if (seen[item] !== 1) {
			seen[item] = 1;
			out[j++] = item;
		}
	}
	return out;
}

/**
 * Retorna o número formatado com #dec# casas decimais
 */
function fn_number_round(val, dec) {
	var base = dec;
	var edit = val + '';
	if (edit.indexOf('.') > -1) {
		edit = edit.substring(edit.indexOf('.'), 8);
		edit = edit.replace('.', '');
		//console.log(edit);
		edit = edit[base];
		//console.log(edit);
		if (Number(edit) > 5) {
			val = Number(Number(val).toFixed(2));
		} else {
			val = num_trunc(val, base);
		}
	} else {
		val = Number(Number(val).toFixed(2));
	}

	return val;
}


function roundDecimalsCorrect(value, decimals) {
	return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals).toFixed(decimals);
}

/**
 * Remove registros duplicados de um array de objetos(originalArray)
 * filtrando por uma propriedade(prop)
 */
function removeDupesInArray(originalArray, prop) {
	var newArray = [];
	var lookupObject = {};

	for (var i in originalArray) {
		lookupObject[originalArray[i][prop]] = originalArray[i];
	}

	for (i in lookupObject) {
		newArray.push(lookupObject[i]);
	}
	return newArray;
}

/**
 * Verificar se o elemento está visível em tela
 * verificação funcional caso o parente do elemento possuir um "scroll" vertical
 */

function checkVisible(elm) {
	var rect = elm.getBoundingClientRect();
	var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
	return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
}

/**
 * Retorna true se a Inscrição Estadual for válida e false se não.
 * Sendo: TheField = IE, estado = UF, msg_sucess = 'mensagem de sucesso', msg_failure = 'mensagem de invalidez'.
 */
function checkInscEstadual(theField, estado, msg_sucess, msg_failure) {
	// var inscEst=retiraCaracteresInvalidos(theField.value);
	if (typeof msg_sucess == 'undefined') { msg_sucess = "Insc. Estadual válida!"; };
	if (typeof msg_failure == 'undefined') { msg_failure = "Insc. Estadual inválida!"; };
	var inscEst = theField;
	if (trim_null(inscEst) != "" && trim_null(inscEst).toUpperCase() != "ISENTO") {
		var dig8 = "/BA*/RJ*";
		var dig9 = "/AL*/AP*/AM*/CE*/ES*/GO*/MA*/MS*/PA*/PB*/PI*/RN*/RR*/SC*/SE*";
		var dig10 = "/PR*/RS*";
		var dig11 = "/MT*/TO*";
		var dig12 = "/SP*";
		var dig13 = "/AC*/MG*/DF*";
		var dig14 = "/PE*/RO*";

		if (dig8.indexOf("/" + estado + "*") != -1) {
			// inscEst=inscEst.substr(0,8);
			var tam = 8;
			var tam2 = 9;
			if (((inscEst).trim()).length > tam && ((inscEst).trim()).length > tam2) {
				showErro(msg_failure);
				return false;
			}
		}
		else if (dig9.indexOf("/" + estado + "*") != -1) {
			// inscEst=inscEst.substr(0,9);
			var tam = 9;
			if (((inscEst).trim()).length > tam) {
				showErro(msg_failure);
				return false;
			}
		}
		else if (dig10.indexOf("/" + estado + "*") != -1) {
			// inscEst=inscEst.substr(0,10);
			var tam = 10;
			if (((inscEst).trim()).length > tam) {
				showErro(msg_failure);
				return false;
			}
		}
		else if (dig11.indexOf("/" + estado + "*") != -1) {
			// inscEst=inscEst.substr(0,11);
			var tam = 11;
			if (((inscEst).trim()).length > tam) {
				showErro(msg_failure);
				return false;
			}
		}
		else if (dig12.indexOf("/" + estado + "*") != -1) {
			// inscEst=inscEst.substr(0,12);
			var tam = 12;
			if (((inscEst).trim()).length > tam) {
				showErro(msg_failure);
				return false;
			}
		}
		else if (dig13.indexOf("/" + estado + "*") != -1) {
			// inscEst=inscEst.substr(0,13);
			var tam = 13;
			if (((inscEst).trim()).length > tam) {
				showErro(msg_failure);
				return false;
			}
		}
		else if (dig14.indexOf("/" + estado + "*") != -1) {
			// inscEst=inscEst.substr(0,14);
			var tam = 14;
			if (((inscEst).trim()).length > tam) {
				showErro(msg_failure);
				return false;
			}
		} else {
			// inscEst="";
			var tam = 0;
			if (((inscEst).trim()).length > tam) {
				showErro(msg_failure);
				return false;
			}
		}
	}

	if (inscEst != "" && trim_null(inscEst).toUpperCase() != "ISENTO") {
		if (estado == "AC") {
			inscEst = strzero(inscEst, 13);
			var primDigito = 0;
			var seguDigito = 0;
			var pesos = "43298765432";
			var soma = 0;
			var i = 0;
			for (i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			primDigito = 11 - (soma % 11);
			if (primDigito > 9)
				primDigito = 0;
			pesos = "543298765432";
			soma = 0;
			for (i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			seguDigito = 11 - (soma % 11);
			if (seguDigito > 9)
				seguDigito = 0;

			if ((parseInt(inscEst.substr(11, 1)) != primDigito) || (parseInt(inscEst.substr(12, 1)) != seguDigito)) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "AL") {
			inscEst = strzero(inscEst, 9);
			var primDigito = 0;
			var pesos = "98765432";
			var soma = 0;
			var i = 0;
			for (i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			soma = soma * 10;
			primDigito = soma % 11;
			if (primDigito > 9)
				primDigito = 0;
			if (parseInt(inscEst.substr(8, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "AP") {
			inscEst = strzero(inscEst, 9);
			if (inscEst.substr(0, 2) != "03") {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else {
				if (parseFloat(inscEst.substr(0, 8)) < 3017000) {
					var p = 5;
					var d = 0;
				}
				else if (parseFloat(inscEst.substr(0, 8)) < 3019022) {
					var p = 9;
					var d = 1;
				}
				else {
					var p = 0;
					var d = 0;
				}
				var primDigito = 0;
				var pesos = "98765432";
				var soma = p;
				var i = 0;
				for (i = 0; i < pesos.length; i++) {
					soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
				}
				primDigito = 11 - (soma % 11);
				if (primDigito == 10)
					primDigito = 0;
				else if (primDigito == 11)
					primDigito = d;
				if (parseInt(inscEst.substr(8, 1)) != primDigito) {
					showErro(msg_failure);

					return false;
					// theField.select();
					// theField.focus();
				}
				else
					theField = inscEst;
			}
		}
		else if (estado == "AM") {
			inscEst = strzero(inscEst, 9);
			var primDigito = 0;
			var pesos = "98765432";
			var soma = 0;
			var i = 0;
			for (i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			if (soma < 11)
				primDigito = 11 - soma;
			else {
				primDigito = soma % 11;
				if (primDigito < 2)
					primDigito = 0;
				else
					primDigito = 11 - primDigito;
			}
			if (parseInt(inscEst.substr(8, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "BA") {
			inscEst = strzero(inscEst, 8);
			if (inscEst.length == 8) {
				var primDigito = 0;
				var seguDigito = 0;
				if ((parseInt(inscEst.substr(0, 1)) < 6) || (parseInt(inscEst.substr(0, 1)) == 8))
					var modulo = 10;
				else
					var modulo = 11;
				var pesos = "765432";
				var soma = 0;
				var i = 0;
				for (var i = 0; i < pesos.length; i++) {
					soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
				}
				seguDigito = modulo - (soma % modulo);
				if (seguDigito > 9)
					seguDigito = 0;
				var inscEstAux = inscEst;
				inscEst = inscEst.substr(0, 6) + "" + inscEst.substr(7, 1) + "" + inscEst.substr(6, 1);
				var pesos = "8765432";
				var soma = 0;
				for (var i = 0; i < pesos.length; i++) {
					soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
				}
				primDigito = modulo - (soma % modulo);
				if (primDigito > 9)
					primDigito = 0;
				inscEst = inscEst.substr(0, 6) + "" + inscEst.substr(7, 1) + "" + inscEst.substr(6, 1);
				if ((parseInt(inscEst.substr(6, 1)) != primDigito) || (parseInt(inscEst.substr(7, 1)) != seguDigito)) {
					showErro(msg_failure);

					return false;
					// theField.select();
					// theField.focus();
				}
				else
					theField = inscEst;
			} else {
				var primDigito = 0;
				var seguDigito = 0;
				var pesos = "8765432";
				var soma = 0;
				var moduler1 = '0,1,2,3,4,5,8';
				if (moduler1.indexOf(inscEst.substr(1, 1)) > -1) {
					var modulo = 10;
				} else {
					var modulo = 11;
				}
				for (var i = 0; i < pesos.length; i++) {
					soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
				}

				//primDigito=modulo-(soma%modulo);
				if (modulo != 11) {
					primDigito = modulo - (soma % modulo);
				} else {
					primDigito = (soma % modulo);
				}

				if ((inscEst[inscEst.length - 1] == primDigito) || (primDigito == 0 && inscEst.substr(1, 1) == primDigito) || ((primDigito == 0 || primDigito == 1) && inscEst[inscEst.length - 1] == 0)) {
					//console.log('valido!')
				} else {
					showErro(msg_failure);
					return false;
					// theField.select();
					// theField.focus();
				}
			}
		}
		else if (estado == "CE") {
			inscEst = strzero(inscEst, 9);
			var primDigito = 0;
			var pesos = "98765432";
			var soma = 0;
			for (var i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			primDigito = 11 - (soma % 11);
			if (primDigito > 9)
				primDigito = 0;
			if (parseInt(inscEst.substr(8, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "DF") {
			inscEst = strzero(inscEst, 13);
			if (inscEst.substr(0, 2) != "07") {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else {
				var primDigito = 0;
				var seguDigito = 0;
				var pesos = "43298765432";
				var soma = 0;
				for (i = 0; i < pesos.length; i++) {
					soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
				}
				primDigito = 11 - (soma % 11);
				if (primDigito > 9)
					primDigito = 0;
				pesos = "543298765432";
				soma = 0;
				for (var i = 0; i < pesos.length; i++) {
					soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
				}
				seguDigito = 11 - (soma % 11);
				if (seguDigito > 9)
					seguDigito = 0;

				if ((parseInt(inscEst.substr(11, 1)) != primDigito) || (parseInt(inscEst.substr(12, 1)) != seguDigito)) {
					showErro(msg_failure);

					return false;
					// theField.select();
					// theField.focus();
				}
				else
					theField = inscEst;
			}
		}
		else if (estado == "ES") {
			inscEst = strzero(inscEst, 9);
			var primDigito = 0;
			var pesos = "98765432";
			var soma = 0;
			for (var i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			primDigito = 11 - (soma % 11);
			if (primDigito > 9)
				primDigito = 0;
			if (parseInt(inscEst.substr(8, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "GO") {
			inscEst = strzero(inscEst, 9);
			var primDigito = 0;
			var pesos = "98765432";
			var soma = 0;
			for (var i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			primDigito = 11 - (soma % 11);
			if (inscEst.substr(0, 8) == "11094402") {
				if ((parseInt(inscEst.substr(8, 1)) != "0") && (parseInt(inscEst.substr(8, 1)) != "1")) {
					showErro(msg_failure);

					return false;
					// theField.select();
					// theField.focus();
				}
			}
			else {
				if (primDigito == 11)
					primDigito = 0;
				else if (primDigito == 10) {
					if ((parseFloat(inscEst.substr(0, 8)) >= 10103105) && (parseFloat(inscEst.substr(0, 8)) <= 10119997))
						primDigito = 1;
					else
						primDigito = 0;
				}
				if (parseInt(inscEst.substr(8, 1)) != primDigito) {
					showErro(msg_failure);

					return false;
					// theField.select();
					// theField.focus();
				}
				else
					theField = inscEst;
			}
		}
		else if (estado == "MA") {
			inscEst = strzero(inscEst, 9);
			if (inscEst.substr(0, 2) != "12") {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else {
				var primDigito = 0;
				var pesos = "98765432";
				var soma = 0;
				for (var i = 0; i < pesos.length; i++) {
					soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
				}
				primDigito = 11 - (soma % 11);
				if (primDigito > 9)
					primDigito = 0;
				if (parseInt(inscEst.substr(8, 1)) != primDigito) {
					showErro(msg_failure);

					return false;
					// theField.select();
					// theField.focus();
				}
				else
					theField = inscEst;
			}
		}
		else if (estado == "MT") {
			inscEst = strzero(inscEst, 11);
			var primDigito = 0;
			var pesos = "3298765432";
			var soma = 0;
			for (var i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			primDigito = 11 - (soma % 11);
			if (primDigito > 9)
				primDigito = 0;
			if (parseInt(inscEst.substr(10, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "MS") {
			inscEst = strzero(inscEst, 9);
			if (inscEst.substr(0, 2) != "28") {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else {
				var primDigito = 0;
				var pesos = "98765432";
				var soma = 0;
				for (var i = 0; i < pesos.length; i++) {
					soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
				}
				primDigito = 11 - (soma % 11);
				if (primDigito > 9)
					primDigito = 0;
				if (parseInt(inscEst.substr(8, 1)) != primDigito) {
					showErro(msg_failure);

					return false;
					// theField.select();
					// theField.focus();
				}
				else
					theField = inscEst;
			}
		}
		else if (estado == "MG") {
			inscEst = strzero(inscEst, 13);
			inscEst = inscEst.substr(0, 3) + "0" + inscEst.substr(3);
			var primDigito = 0;
			var seguDigito = 0;
			var pesos = "121212121212";
			var soma = 0;
			var resultado = 0;
			var i = 0;
			var j = 0;
			for (i = 0; i < pesos.length; i++) {
				resultado = parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1));
				resultado = resultado + "";
				for (j = 0; j < resultado.length; j++) {
					soma = soma + (parseInt(resultado.substr(j, 1)));
				}
			}
			var somaAux = soma + "";
			primDigito = parseInt((parseInt(somaAux.substr(0, 1)) + 1) + "0") - soma;
			if (primDigito > 9)
				primDigito = 0;
			inscEst = inscEst.substr(0, 3) + inscEst.substr(4);
			pesos = "321098765432";
			soma = 0;
			for (i = 0; i < pesos.length; i++) {
				var mult = parseInt(pesos.substr(i, 1));
				if ((i > 1) && (i < 4))
					mult = parseInt(pesos.substr(i, 1)) + 10;
				soma = soma + (parseInt(inscEst.substr(i, 1)) * mult);
			}
			seguDigito = 11 - (soma % 11);
			if (seguDigito > 9)
				seguDigito = 0;

			if ((parseInt(inscEst.substr(11, 1)) != primDigito) || (parseInt(inscEst.substr(12, 1)) != seguDigito)) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}



		else if (estado == "PA") {
			inscEst = strzero(inscEst, 9);
			if (inscEst.substr(0, 2) != "15") {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else {
				var primDigito = 0;
				var pesos = "98765432";
				var soma = 0;
				for (var i = 0; i < pesos.length; i++) {
					soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
				}
				primDigito = 11 - (soma % 11);
				if (primDigito > 9)
					primDigito = 0;
				if (parseInt(inscEst.substr(8, 1)) != primDigito) {
					showErro(msg_failure);

					return false;
					// theField.select();
					// theField.focus();
				}
				else
					theField = inscEst;
			}
		}
		else if (estado == "PB") {
			inscEst = strzero(inscEst, 9);
			var primDigito = 0;
			var pesos = "98765432";
			var soma = 0;
			for (var i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			primDigito = 11 - (soma % 11);
			if (primDigito > 9)
				primDigito = 0;
			if (parseInt(inscEst.substr(8, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "PR") {
			inscEst = strzero(inscEst, 10);
			var primDigito = 0;
			var seguDigito = 0;
			var pesos = "32765432";
			var soma = 0;
			var i = 0;
			for (i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			primDigito = 11 - (soma % 11);
			if (primDigito > 9)
				primDigito = 0;
			pesos = "432765432";
			soma = 0;
			for (i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			seguDigito = 11 - (soma % 11);
			if (seguDigito > 9)
				seguDigito = 0;

			if ((parseInt(inscEst.substr(8, 1)) != primDigito) || (parseInt(inscEst.substr(9, 1)) != seguDigito)) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "PE") {
			inscEst = strzero(inscEst, 14);
			var primDigito = 0;
			var pesos = "5432198765432";
			var soma = 0;
			var i = 0;
			for (i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			primDigito = 11 - (soma % 11);
			if (primDigito > 9)
				primDigito = primDigito - 10;
			if (parseInt(inscEst.substr(13, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "PI") {
			inscEst = strzero(inscEst, 9);
			var primDigito = 0;
			var pesos = "98765432";
			var soma = 0;
			var i = 0;
			for (i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			primDigito = 11 - (soma % 11);
			if (primDigito > 9)
				primDigito = 0;
			if (parseInt(inscEst.substr(8, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "RJ") {
			inscEst = strzero(inscEst, 8);
			var primDigito = 0;
			var pesos = "2765432";
			var soma = 0;
			var i = 0;
			for (i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			primDigito = 11 - (soma % 11);
			if (primDigito > 9)
				primDigito = 0;
			if (parseInt(inscEst.substr(7, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "RN") {
			inscEst = strzero(inscEst, 9);
			var primDigito = 0;
			var pesos = "98765432";
			var soma = 0;
			var i = 0;
			for (i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			soma = soma * 10;
			primDigito = soma % 11;
			if (primDigito > 9)
				primDigito = 0;
			if (parseInt(inscEst.substr(8, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "RS") {
			inscEst = strzero(inscEst, 10);
			var primDigito = 0;
			var pesos = "298765432";
			var soma = 0;
			var i = 0;
			for (i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			primDigito = 11 - (soma % 11);
			if (primDigito > 9)
				primDigito = 0;
			if (parseInt(inscEst.substr(9, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "RO") {
			inscEst = strzero(inscEst, 14);
			var primDigito = 0;
			var pesos = "6543298765432";
			var soma = 0;
			for (var i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			primDigito = 11 - (soma % 11);
			if (primDigito > 9)
				primDigito -= 10;
			if (parseInt(inscEst.substr(13, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "RR") {
			inscEst = strzero(inscEst, 9);
			var primDigito = 0;
			var pesos = "12345678";
			var soma = 0;
			var i = 0;
			for (i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			soma = soma * 10;
			primDigito = soma % 9;
			if (parseInt(inscEst.substr(8, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "SC") {
			inscEst = strzero(inscEst, 9);
			var primDigito = 0;
			var pesos = "98765432";
			var soma = 0;
			var i = 0;
			for (i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			soma = soma * 10;
			primDigito = soma % 11;
			if (primDigito > 9)
				primDigito = 0;
			if (parseInt(inscEst.substr(8, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "SP") {
			inscEst = strzero(inscEst, 12);
			var primDigito = 0;
			var seguDigito = 0;
			var pesos = "13456780";
			var soma = 0;
			var i = 0;
			var mult = 0;
			for (i = 0; i < pesos.length; i++) {
				mult = parseInt(pesos.substr(i, 1));
				if (i == 7)
					mult = 10;
				soma = soma + (parseInt(inscEst.substr(i, 1)) * mult);
			}
			primDigito = soma % 11;
			if (primDigito > 9)
				primDigito = 0;
			pesos = "32098765432";
			soma = 0;
			for (i = 0; i < pesos.length; i++) {
				mult = parseInt(pesos.substr(i, 1));
				if (i == 2)
					mult = 10;
				soma = soma + (parseInt(inscEst.substr(i, 1)) * mult);
			}
			seguDigito = soma % 11;
			if (seguDigito > 9)
				seguDigito = 0;

			if ((parseInt(inscEst.substr(8, 1)) != primDigito) || (parseInt(inscEst.substr(11, 1)) != seguDigito)) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "SE") {
			inscEst = strzero(inscEst, 9);
			var primDigito = 0;
			// 9 8 7 6 5 4 3 2
			var pesos = "98765432";
			var soma = 0;
			for (var i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			// soma=soma*10;
			primDigito = 11 - (soma % 11);
			if (primDigito > 9)
				primDigito = 0;
			if (parseInt(inscEst.substr(8, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
		}
		else if (estado == "TO") {
			// inscEst=inscEst.replace(inscEst.substr(2,2),'');
			inscEst = strzero(inscEst, 9); // 11 Se tiver 2 algarismos
			//if ((inscEst.substr(2,2) != "01") && (inscEst.substr(2,2) != "02") && (inscEst.substr(2,2) != "03") && (inscEst.substr(2,2) != "99")) {
			//    showErro(msg_failure);
			//    theField.select();
			//    theField.focus();
			//}
			//else {
			var primDigito = 0;
			// var pesos="9800765432";
			var pesos = "98765432";
			var soma = 0;
			var i = 0;
			for (i = 0; i < pesos.length; i++) {
				soma = soma + (parseInt(inscEst.substr(i, 1)) * parseInt(pesos.substr(i, 1)));
			}
			primDigito = 11 - (soma % 11);
			if (primDigito > 9)
				primDigito = 0;
			if (parseInt(inscEst.substr(8, 1)) != primDigito) {
				showErro(msg_failure);

				return false;
				// theField.select();
				// theField.focus();
			}
			else
				theField = inscEst;
			//}
		}
	}

	if (theField != "" && theField != "ISENTO") {
		showSuccess(msg_sucess);
		return true;
	}

	// return theField;
}

function checkCNPJ(cnpj, msg_sucess, msg_failure) { 
	if (typeof msg_sucess == 'undefined') { msg_sucess = "CNPJ válido!"; };
	if (typeof msg_failure == 'undefined') { msg_failure = "CNPJ inválido!"; };

	cnpj = cnpj.replace(/[^\d]+/g, '');

	if (cnpj == '') {
		showErro(msg_failure);
		return false;
	}

	if (cnpj.length != 14) {
		showErro(msg_failure);
		return false;
	}

	// Elimina CNPJs invalidos conhecidos
	if (cnpj == "11111111111111" || cnpj == "22222222222222" || cnpj == "33333333333333" || cnpj == "44444444444444" || cnpj == "55555555555555" || cnpj == "66666666666666" || cnpj == "77777777777777" || cnpj == "88888888888888" || cnpj == "99999999999999") {
		showErro(msg_failure);
		return false;
	}

	// Valida DVs
	var resultado = 0;

	var tamanho = cnpj.length - 2
	var numeros = cnpj.substring(0, tamanho);
	var digitos = cnpj.substring(tamanho);
	var soma = 0;
	var pos = tamanho - 7;

	for (var i = tamanho; i >= 1; i--) {
		soma += numeros.charAt(tamanho - i) * pos--;
		if (pos < 2) {
			pos = 9;
		}
	}

	resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

	if (resultado != digitos.charAt(0)) {
		showErro(msg_failure);
		return false;
	}

	tamanho = tamanho + 1;
	numeros = cnpj.substring(0, tamanho);
	soma = 0;
	pos = tamanho - 7;

	for (var i = tamanho; i >= 1; i--) {
		soma += numeros.charAt(tamanho - i) * pos--;
		if (pos < 2) {
			pos = 9;
		}
	}

	resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

	if (resultado != digitos.charAt(1)) {
		showErro(msg_failure);
		return false;
	}

	if (cnpj != "") {
		showSuccess(msg_sucess);
		return true;
	}
}

/**
 * Retorna true se o(s) email(s) for(em) válido(s).
  * @param {separador} String or Array
  * @param {emails} String
 */
function checkEmail(separador, emails, exibirErro, naoExibirErro = false) {
	// Define se é 1 ou mais Emails no campo
	var multi_emails = false;

	var usuario = '';
	var dominio = '';
	if (Array.isArray(separador)) {

		for (var indice = 0; indice < separador.length; indice++) {
			var elemento = separador[indice];
			// Verifica a quantidade de Emails no campo utilizando o separador informado (Tela 12241 Utiliza ";")
			if (emails.indexOf(elemento) > -1) {
				//se for mais de 1 email
				multi_emails = true;
				emails = emails.split(elemento);
				break;
			}
		}

	} else {
		// Verifica a quantidade de Emails no campo utilizando o separador informado (Tela 12241 Utiliza ";")
		if (emails.indexOf(separador) > -1) {
			//se for mais de 1 email
			multi_emails = true;
			emails = emails.split(separador);
		}
		var elemento = separador;
	}

	if (multi_emails == true) {
		// Validação de Multiplus Emails
		var a = 0;
		for (var index = 0; index < emails.length; index++) {
			var element = emails[index];

			if (element != '') {
				usuario = (element.substring(0, element.indexOf("@"))).replace(' ', '');
				dominio = (element.substring(element.indexOf("@") + 1, element.length)).replace(' ', '');

				if ((usuario.length >= 1) && (dominio.length >= 3) && (usuario.search("@") == -1) && (dominio.search("@") == -1) && (usuario.search(" ") == -1) && (dominio.search(" ") == -1) && (dominio.search(".") != -1) && (dominio.indexOf(".") >= 1) && (dominio.lastIndexOf(".") < dominio.length - 1)) {
					a = ++a;
				} else {
					if (typeof exibirErro == 'undefined') {
						showErro('O Email ' + element + ' é inválido.');
					} else if (typeof exibirErro === 'string' || exibirErro instanceof String) {
						showErro(exibirErro);
					} else if (typeof exibirErro === 'function') {
						showErro(exibirErro(element));
					}
					return false;
				}
			}
		}
		if (a == 0) {
			showErro('É necessário ao menos 1 Email válido.');
			return false;
		}
		console.log('Emails Verificados!');
	} else {
		// Validação de 1 Email
		usuario = (emails.substring(0, emails.indexOf("@"))).replace(' ', '');
		dominio = (emails.substring(emails.indexOf("@") + 1, emails.length)).replace(' ', '');

		if ((usuario.length >= 1) && (dominio.length >= 3) && (usuario.search("@") == -1) && (dominio.search("@") == -1) && (usuario.search(" ") == -1) && (dominio.search(" ") == -1) && (dominio.search(".") != -1) && (dominio.indexOf(".") >= 1) && (dominio.lastIndexOf(".") < dominio.length - 1)) {
			console.log('Email Verificado!');
		} else {
			if(naoExibirErro == false){
				if (typeof exibirErro == 'undefined') {
					showErro('O Email ' + emails + ' é inválido.');
				} else if (typeof exibirErro === 'string' || exibirErro instanceof String) {
					showErro(exibirErro);
				} else if (typeof exibirErro === 'function') {
					showErro(exibirErro(emails));
				}
			}
			return false;
		}
	}

	return true;
}

/* function checkEmail2(separador, emails){
	// Define se é 1 ou mais Emails no campo
	var multi_emails = false;

	// Verifica a quantidade de Emails no campo utilizando o separador informado (Tela 12241 Utiliza ";")
	if(emails.indexOf(separador) > -1){
		//se for mais de 1 email
		multi_emails = true;
		emails = emails.split(separador);
	}
	
	var usuario = '';
	var dominio = '';
			
	if(multi_emails == true){
		// Validação de Multiplus Emails
		var a = 0;
		for (var index = 0; index < emails.length; index++) {
			var element = emails[index];
			
			if(element != ''){
				usuario = (element.substring(0, element.indexOf("@"))).replace(' ', '');
				dominio = (element.substring(element.indexOf("@")+ 1 , element.length)).replace(' ', '');
				
				if ((usuario.length >=1) && (dominio.length >=3) && (usuario.search("@")==-1) && (dominio.search("@")==-1) && (usuario.search(" ")==-1) && (dominio.search(" ")==-1) && (dominio.search(".")!=-1) && (dominio.indexOf(".") >=1) && (dominio.lastIndexOf(".") < dominio.length - 1)){
					a = ++a;
				}else{
					return false;
				}
			}
		}
		if(a == 0){
			showErro('É necessário ao menos 1 Email válido.');
			return false;
		}
		console.log('Emails Verificados!');
	}else{
		// Validação de 1 Email
		usuario = (emails.substring(0, emails.indexOf("@"))).replace(' ', '');
		dominio = (emails.substring(emails.indexOf("@")+ 1, emails.length)).replace(' ', '');
			
		if ((usuario.length >=1) && (dominio.length >=3) && (usuario.search("@")==-1) && (dominio.search("@")==-1) && (usuario.search(" ")==-1) && (dominio.search(" ")==-1) && (dominio.search(".")!=-1) && (dominio.indexOf(".") >=1) && (dominio.lastIndexOf(".") < dominio.length - 1)){
			console.log('Email Verificado!');
		}else{
			return false;
		}
	}
	
	return true;
} */

/** Formata um número de telefone sem o código do país
 * Ex.: (85) 98888-8888
 * 
 * @param {string} phone 
 * @returns {string}
 */
function formatPhone(phone) {
	// Remove tudo o que não é dígito
	phone = phone.replace(/\D/g, '');

	// realiza formatação...
	phone = phone.replace(/^(\d{2})(\d)/g, "(\$1) \$2");	//Coloca parênteses em volta dos dois primeiros dígitos
	phone = phone.replace(/(\d)(\d{4})$/g, "\$1-\$2");		//Coloca hífen entre o quarto e o quinto dígitos

	return phone;
}

/** Formata um número em forma de CPF ou CNPJ
 * Ex.: 111.111.111-11 | 11.111.111/1111-11
 * 
 * Se conter 11 ou menos numeros formata em CPF, mais de 14 formata em CNPJ
 * 
 * @param {string} cpf 
 * @returns {string}
 */
function formatCPFCNPJ(cpf) {
	//retira os caracteres indesejados...
	var ret = cpf.replace(/\D/g, '');

	//realizar a formatação...
	if (ret.length <= 11) {
		ret = ret.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3-\$4");				// Formata em CPF
	} else {
		ret = ret.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3/\$4-\$5");	// Formata em CNPJ
	}

	return ret;
}

function checkCPF(cpf, msg_sucess, msg_failure) {
	if (typeof msg_sucess == 'undefined') { msg_sucess = "CPF válido!"; };
	if (typeof msg_failure == 'undefined') { msg_failure = "CPF inválido!"; };

	cpf = cpf.replace(/[^\d]+/g, '');

	var resto = 0;
	var soma = 0;

	if (cpf == "00000000000") {
		showErro(msg_failure);
		return false;
	}

	for (var i = 1; i <= 9; i++) {
		soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
		resto = (soma * 10) % 11;
	}

	if ((resto == 10) || (resto == 11)) {
		resto = 0;
	}
	if (resto != parseInt(cpf.substring(9, 10))) {
		showErro(msg_failure);
		return false;
	}

	soma = 0;
	for (var i = 1; i <= 10; i++) {
		soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
		resto = (soma * 10) % 11;
	}

	if ((resto == 10) || (resto == 11)) {
		resto = 0;
	}

	if (resto != parseInt(cpf.substring(10, 11))) {
		showErro(msg_failure);
		return false;
	}

	if (cpf != "") {
		showSuccess(msg_sucess);
		return true;
	}
}

function checkCPF2(cpf, msg_failure) {
	// if(typeof msg_sucess == 'undefined'){ msg_sucess = "CPF válido!"; };
	if (typeof msg_failure == 'undefined') { msg_failure = "CPF inválido!"; };

	cpf = cpf.replace(/[^\d]+/g, '');

	var resto = 0;
	var soma = 0;

	if (cpf == "00000000000") {
		showErro(msg_failure);
		return false;
	}

	for (var i = 1; i <= 9; i++) {
		soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
		resto = (soma * 10) % 11;
	}

	if ((resto == 10) || (resto == 11)) {
		resto = 0;
	}
	if (resto != parseInt(cpf.substring(9, 10))) {
		showErro(msg_failure);
		return false;
	}

	soma = 0;
	for (var i = 1; i <= 10; i++) {
		soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
		resto = (soma * 10) % 11;
	}

	if ((resto == 10) || (resto == 11)) {
		resto = 0;
	}

	if (resto != parseInt(cpf.substring(10, 11))) {
		showErro(msg_failure);
		return false;
	}

	if (cpf != "") {
		// showSuccess(msg_sucess);
		return true;
	}
}

function validarTitulo(inscricao, msg_failure) {
	if (typeof msg_failure == 'undefined') { msg_failure = "Título de Eleitor inválido!"; };
	var paddedInsc = inscricao;
	//alert("validando inscricao " + paddedInsc);
	var dig1 = 0;
	var dig2 = 0;

	var tam = paddedInsc.length;
	var digitos = paddedInsc.substr(tam - 2, 2);
	var estado = paddedInsc.substr(tam - 4, 2);
	var titulo = paddedInsc.substr(0, tam - 2);
	var exce = (estado == '01') || (estado == '02');
	dig1 = (titulo.charCodeAt(0) - 48) * 9 + (titulo.charCodeAt(1) - 48) * 8 +
		(titulo.charCodeAt(2) - 48) * 7 + (titulo.charCodeAt(3) - 48) * 6 +
		(titulo.charCodeAt(4) - 48) * 5 + (titulo.charCodeAt(5) - 48) * 4 +
		(titulo.charCodeAt(6) - 48) * 3 + (titulo.charCodeAt(7) - 48) * 2;
	var resto = (dig1 % 11);
	if (resto == 0) {
		if (exce) {
			dig1 = 1;
		} else {
			dig1 = 0;
		}
	} else {
		if (resto == 1) {
			dig1 = 0;
		} else {
			dig1 = 11 - resto;
		}
	}

	dig2 = (titulo.charCodeAt(8) - 48) * 4 + (titulo.charCodeAt(9) - 48) * 3 + dig1 * 2;
	resto = (dig2 % 11);
	if (resto == 0) {
		if (exce) {
			dig2 = 1;
		} else {
			dig2 = 0;
		}
	} else {
		if (resto == 1) {
			dig2 = 0;
		} else {
			dig2 = 11 - resto;
		}
	}

	if ((digitos.charCodeAt(0) - 48 == dig1) && (digitos.charCodeAt(1) - 48 == dig2)) {
		return true; // Titulo valido
	} else {
		showErro(msg_failure);
		return false;
	}

}

function validarPIS(pis, msg_failure) {
	if (typeof msg_failure == 'undefined') { msg_failure = "PIS inválido!"; };
	var multiplicadorBase = "3298765432";
	var total = 0;
	var resto = 0;
	var multiplicando = 0;
	var multiplicador = 0;
	var digito = 99;

	// Retira a mascara
	var numeroPIS = pis.replace(/[^\d]+/g, '');

	if (numeroPIS.length !== 11 ||
		numeroPIS === "00000000000" ||
		numeroPIS === "11111111111" ||
		numeroPIS === "22222222222" ||
		numeroPIS === "33333333333" ||
		numeroPIS === "44444444444" ||
		numeroPIS === "55555555555" ||
		numeroPIS === "66666666666" ||
		numeroPIS === "77777777777" ||
		numeroPIS === "88888888888" ||
		numeroPIS === "99999999999") {

		showErro(msg_failure);
		return false;
	} else {
		for (var i = 0; i < 10; i++) {
			multiplicando = parseInt(numeroPIS.substring(i, i + 1));
			multiplicador = parseInt(multiplicadorBase.substring(i, i + 1));
			total += multiplicando * multiplicador;
		}

		resto = 11 - total % 11;
		resto = resto === 10 || resto === 11 ? 0 : resto;

		digito = parseInt("" + numeroPIS.charAt(10));
		return resto === digito;
	}
}

function checkSamePropertyValue(arr, propName) {
	if (arr.length === 0) {
	  // Return true for an empty array since there are no objects to compare.
	  return true;
	}
  
	const firstValue = arr[0][propName];
  
	// Use the every() method to check if all objects have the same property value.
	return arr.every(obj => obj[propName] === firstValue);
}

function formatNumber(number, decimals, decPoint, thousandsSep) { // eslint-disable-line camelcase
	//  discuss at: http://locutus.io/php/number_format/
	// original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	// improved by: Kevin van Zonneveld (http://kvz.io)
	// improved by: davook
	// improved by: Brett Zamir (http://brett-zamir.me)
	// improved by: Brett Zamir (http://brett-zamir.me)
	// improved by: Theriault (https://github.com/Theriault)
	// improved by: Kevin van Zonneveld (http://kvz.io)
	// bugfixed by: Michael White (http://getsprink.com)
	// bugfixed by: Benjamin Lupton
	// bugfixed by: Allan Jensen (http://www.winternet.no)
	// bugfixed by: Howard Yeend
	// bugfixed by: Diogo Resende
	// bugfixed by: Rival
	// bugfixed by: Brett Zamir (http://brett-zamir.me)
	//  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	//  revised by: Luke Smith (http://lucassmith.name)
	//    input by: Kheang Hok Chin (http://www.distantia.ca/)
	//    input by: Jay Klehr
	//    input by: Amir Habibi (http://www.residence-mixte.com/)
	//    input by: Amirouche
	//   example 1: number_format(1234.56)
	//   returns 1: '1,235'
	//   example 2: number_format(1234.56, 2, ',', ' ')
	//   returns 2: '1 234,56'
	//   example 3: number_format(1234.5678, 2, '.', '')
	//   returns 3: '1234.57'
	//   example 4: number_format(67, 2, ',', '.')
	//   returns 4: '67,00'
	//   example 5: number_format(1000)
	//   returns 5: '1,000'
	//   example 6: number_format(67.311, 2)
	//   returns 6: '67.31'
	//   example 7: number_format(1000.55, 1)
	//   returns 7: '1,000.6'
	//   example 8: formatNumber(67000, 5, ',', '.')
	//   returns 8: '67.000,00000'
	//   example 9: number_format(0.9, 0)
	//   returns 9: '1'
	//  example 10: number_format('1.20', 2)
	//  returns 10: '1.20'
	//  example 11: number_format('1.20', 4)
	//  returns 11: '1.2000'
	//  example 12: number_format('1.2000', 3)
	//  returns 12: '1.200'
	//  example 13: number_format('1 000,50', 2, '.', ' ')
	//  returns 13: '100 050.00'
	//  example 14: number_format(1e-8, 8, '.', '')
	//  returns 14: '0.00000001'

	number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
	var n = !isFinite(+number) ? 0 : +number
	var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
	var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
	var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
	var s = ''

	var toFixedFix = function (n, prec) {
		var k = Math.pow(10, prec)
		return '' + (Math.round(n * k) / k)
			.toFixed(prec)
	}

	// @todo: for IE parseFloat(0.55).toFixed(0) = 0;

	if (prec) {
		//s = '' + toFixedFix(n, prec);
		s = '' + parseFloat(n).toFixed(prec);
	} else {
		s = '' + Math.round(n);
	}

	s = s.split('.');


	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
	}
	if ((s[1] || '').length < prec) {
		s[1] = s[1] || ''
		s[1] += new Array(prec - s[1].length + 1).join('0')
	}

	return s.join(dec)
}
/**
 * Retorna um número formatado as casas decimais informadas.
 * @param {num} num
 * @param {fixed} fixed
 */
function toFixedGen(num, fixed) {
	var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
	return num.toString().match(re)[0];
}
/**
 * Retorna um número em formato monetário com as casas decimais informadas.
 * @param {num} num
 * @param {fixed} fixed
 */
function toFixedGenMoney(num, fixed) {
	var value = num;
	if (num == 0) {
		value = '0,00';
	} else if (value === parseInt(value, 10)) {
		value = value + ',00';
	} else {
		var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
		//return num.toString().match(re)[0];
		value = num.toString().match(re)[0];
		// replace decimal point character with ,
		value = value.replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
	}
	return value;
}

/**
 * Formata um número para monetário com o prefixo da moeda
 * @param {integer} valor Valor 
 * @param {string} prefixo Simbolo monetário (Se não for passado, recebe R$ por padrão)
 * @returns 
 */
function formatarParaMonetario(valor, prefixo = 'R$') {

	valor = Number(valor);
	prefixo = trim_null(prefixo);

	// Verifica se o valor é um número
	if (trim_null(valor) == '' || isNaN(valor)) {
		console.log('Valor informado não foi formatado');
		return valor;
	} else {

		// Converte o valor para string e adiciona separador de milhar
		let valorFormatado = parseFloat(valor).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&#');

		// Troca o ponto das casas decimais por vírgula
		valorFormatado = valorFormatado.replace('.', ',');
		valorFormatado = valorFormatado.replace(/(#)/g, '.');

		// Adiciona o símbolo da moeda
		valorFormatado = prefixo +' '+ valorFormatado;

		return valorFormatado;
	}
}

// /**
//  * Retorna um número em formato monetário com as casas decimais informadas (EXIGE ES6) 
//  * @param {amount} Valor Valor a ser Formatado
//  * @param {decimalCount} Decimais Número de Casas Decimais (Opcional, Padrão: 2)
//  * @param {decimal} Decimal  Separador de Casas Decimais (Opcional, Padrão: Vírgula)
//  * @param {thousands} Milhões Separador de Casas Milhões (Opcional, Padrão: Ponto)
//  */
// function formatMoneyES6(amount, decimalCount = 2, decimal = ",", thousands = ".") {
// 	try {
// 	  decimalCount = Math.abs(decimalCount);
// 	  decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

// 	  var negativeSign = amount < 0 ? "-" : "";

// 	  var i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
// 	  var j = (i.length > 3) ? i.length % 3 : 0;

// 	  return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
// 	} catch (e) {
// 	  console.log(e)
// 	}
// };
/**
 * Retorna um número em formato monetário com as casas decimais informadas
 * @param {amount} Valor Valor a ser Formatado
 * @param {decPlaces} Decimais Número de Casas Decimais (Opcional, Padrão: 2)
 * @param {decSep} Decimal  Separador de Casas Decimais (Opcional, Padrão: Vírgula)
 * @param {thouSep} Milhões Separador de Casas Milhões (Opcional, Padrão: Ponto)
 */
function formatMoneyES5(number, decPlaces, decSep, thouSep) {
	decPlaces = typeof decPlaces == 'undefined' ? 2 : decPlaces;
	decSep = typeof decSep == 'undefined' ? ',' : decSep;
	thouSep = typeof thouSep == 'undefined' ? '.' : thouSep;
	decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
		decSep = typeof decSep === "undefined" ? "." : decSep;
	thouSep = typeof thouSep === "undefined" ? "," : thouSep;
	var sign = number < 0 ? "-" : "";
	var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
	var j = (j = i.length) > 3 ? j % 3 : 0;

	return sign +
		(j ? i.substr(0, j) + thouSep : "") +
		i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
		(decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
}

/**
 * Retorna um número em formato monetário com as casas decimais informadas
 * @param {amount} Valor Valor a ser Formatado
 * @param {decPlaces} Decimais Número de Casas Decimais (Opcional, Padrão: 2)
 * @param {decSep} Decimal  Separador de Casas Decimais (Opcional, Padrão: Vírgula)
 * @param {thouSep} Milhões Separador de Casas Milhões (Opcional, Padrão: Ponto)
 */

function formatMoneyES52(number) {
	var ending = '';
	if (trim_null(number).indexOf('.') == -1) {
		ending = ',00';
	}
	return 'R$ ' + Number((number).toFixed(2)).toLocaleString() + ending;
}


function arrayFind(items, array) {
	var model = array.model;
	var fields = array.fields;
	var clearOnEmpty = array.clearOnEmpty || false;
	var filtered = [];

	var inFields = function (row, query) {
		var finded = false;

		if (fields == 'all') {
			fields = [];

			for (var k in row) {
				fields.push(k);
			}
		}

		for (var i in fields) {
			var field = row[fields[i]];
			if (field != undefined) {

				var val = row[fields[i]];

				if (!(typeof val == 'string')) {
					val = val.toString();
				}

				val = removeAcento(val);

				if (val != undefined && val != null) {
					val = val.toLowerCase();
				}

				finded = val.indexOf(query || '') !== -1;

			}
			if (finded) break;
		}
		return finded;
	};

	if (clearOnEmpty && model == "") return filtered;

	for (var i in items) {
		var row = items[i];
		var query = removeAcento(model);


		if (query != undefined && query != null) {
			query = query.toLowerCase();
		}

		if (query != undefined && query != null && query.indexOf(" ") > 0) {
			var query_array = query.split(" ");
			var x;
			for (x in query_array) {
				query = query_array[x];
				var search_result = true;
				if (!inFields(row, query)) {
					search_result = false;
					break;
				}
			}
		} else {
			search_result = inFields(row, query);
		}
		if (search_result) {
			filtered.push(row);
		}
	}
	return filtered;
};



/**
 * Converte a quantidade de minutos (min) 
 * em uma String em formato hh:mm.
 */
function minutes_to_hours(min) {
	var h = Math.floor(min / 60);
	var m = min % 60;
	h = h < 10 ? '0' + h : h;
	m = m < 10 ? '0' + m : m;
	//return `${h}:${m}`;
	return '' + h + ':' + m + '';
}

function minutes_to_hours2(min) {
	var tag = '';

	if (min < 0) {
		min = min * -1;
		tag = '-';
	}

	var h = Math.floor(min / 60);
	var m = min % 60;

	if (h > 0) {
		h = h > 10 ? h : '0' + h;
	} else {
		h = h > (10 * (-1)) ? '0' + h : h;
	}

	m = m > 10 ? m : '0' + m;

	if (('' + m).includes('-') && ('' + h).includes('-')) {
		m = ('' + m).replace('-', '');
	}

	if (('' + h).includes('0-')) {
		h = ('' + h).replace('0-', '-0');
	}

	return tag + h + ':' + m + '';
}


function tratarSobraProducao(e) {
	console.log(e);

	var modal = $(e).closest('.modal-content');

	var produzido = $(modal).find('.qtd-prod-conf').val();
	var projetado = $(modal).find('.projetado-prod-conf').val();
	var aproveitamento = $(modal).find('.aproveitamento-prod-conf').val();

	var sobra = (produzido - (projetado - aproveitamento)).toFixed(2);

	$(modal).find('.sobras').html(sobra);
	$(modal).find('.sobra-prod-conf').val(sobra);
}

function selectClassificacao(e) {

	$('.select_classificacao').removeClass('selected');
	$(e).addClass('selected');
	var consumo = $(e).data('consumo');
	var classificacao = $(e).data('classificacao');

	$('.tabela-consumo-' + consumo).find('.peca-classificacao-tab').hide();
	$('.tabela-consumo-' + consumo).find('.peca-' + classificacao).show();
}

function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function getCookieJS(cookieName) {
	var name = cookieName + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var cookieArray = decodedCookie.split(";");

	for (var i = 0; i < cookieArray.length; i++) {
		var cookie = cookieArray[i].trim();

		if (cookie.indexOf(name) === 0) {
			return cookie.substring(name.length, cookie.length);
		}
	}

	return "";
}

function decodeHtmlEntities(text) {
	const parser = new DOMParser();
	const doc = parser.parseFromString(text, "text/html");
	return doc.documentElement.textContent;
}

var list_random_color = [];
function getRandomColorlist(key) {

	var na_lista = false;
	var cor = '';

	if (key > 0) {


		for (var index = 0; index < list_random_color.length; index++) {
			var item = list_random_color[index];

			if (item.KEY == key) {
				na_lista = true;
				cor = item.COR;
			}

		}

		if (na_lista == false) {
			cor = getRandomColor();
			list_random_color.push({ KEY: key, COR: cor });
		}

	} else {
		cor = '#FFFFFF';
	}

	return cor;

}

/**
 * Retorna um array com todas as datas em um período informado.
 * @param {Date} startDate
 * @param {Date} stopDate
 */

function getDatesf(startDate, stopDate) {
	var dateArray = new Array();
	var currentDate = startDate;
	while (currentDate <= stopDate) {
		dateArray.push(moment(currentDate).format('DD.MM.YYYY'));
		currentDate = currentDate.addDays(1);
	}
	return dateArray;
}

function calcularQuantidadeDecimais(number) {
	var quantidadeDecimais = 0;
	var contarDecimaisNumber = countDecimals(number);

	if (contarDecimaisNumber < 2) {
		quantidadeDecimais = 2;
	} else if (contarDecimaisNumber > 5) {
		quantidadeDecimais = 5;
	} else {
		quantidadeDecimais = contarDecimaisNumber;
	}

	return quantidadeDecimais;
}

function countDecimals(number) {
	if (Math.floor(number.valueOf()) === number.valueOf()) return 0;

	return number.toString().split(".")[1].length || 0;
}

/**
 * Retorna a quantidade de Dias no mês informado.
 * @param {number} mes
 * @param {number} ano
 * @returns {number}
 */
function diasNoMes(mes, ano) {
	var diasMes = 0;

	var data = new Date(ano, mes, 0);

	diasMes = data.getDate();
	diasMes = Number(diasMes)

	return diasMes;
}


/**
 * Retorna um número formatado as casas decimais informadas.
 * @param {número} num
 * @param {precisao} precisao
 */
function trunc_number(num, precisao) {
	var decimais = Math.pow(10, precisao);
	return Math.floor(num * decimais) / decimais;
};
/**
 * Retorna um número validado de uma string.
 * @param {número} str 
 */
function convertStringToNumberF(str) {
	var vls = '';

	if (typeof str == 'undefined') {
		str = 0;
	}

	if (typeof str === 'string' || str instanceof String){
		str = str.replace('\ufffd','')
	}

	if ((str + '').indexOf('.') > -1 && (str + '').indexOf(',') > -1) {
		var vlsNoPoint = (str + '').replace('.', '');
		var vlsVirguleToPoint = (vlsNoPoint + '').replace(',', '.');
		vls = vlsVirguleToPoint;
	} else if ((str + '').indexOf('.') > -1 && (str + '').indexOf(',') == -1) {
		vls = str;
	} else if ((str + '').indexOf('.') == -1 && (str + '').indexOf(',') > -1) {
		var vlsVirguleToPoint = (str + '').replace(',', '.');
		vls = vlsVirguleToPoint;
	} else {
		if (isNaN(str) == false) {
			vls = str;
		}
	}

	var b = Number(vls);

	if (isNaN(b)) {
		b = 0;
	}

	return b;
};

function isNumber(n) {
	return !isNaN(parseFloat(n)) && !isNaN(n - 0)
}

/**
 * Retorna uma string sem espaços do valor enviado.
 * @param {string} valor
 */
function trim_null(valor) {
	if (valor !== null && typeof valor !== 'undefined') {
		valor = ((valor + '').trim());
	} else {
		valor = '';
	}
	return valor;
}

/**
 * Realizar um envio de arquivo por email.
 * @param {object} parans
 */
function sendEmailDefault(parans) {

	var that = parans.MODEL_OBJECT;
	var gScope = parans.gScope;
	var CKEDITOR = parans.CKEDITOR;

	that.MODEL_NAME = parans.MODEL_NAME;
	that.TITULO = parans.TITULO;
	that.TITULO_MODAL = parans.TITULO_MODAL;
	that.ASSUNTO = parans.ASSUNTO;
	that.EMAIL = parans.EMAIL;
	that.FILE_DATA = parans.FILE_DATA;
	that.TIPO = parans.TIPO;
	that.CORPO_EMAIL = parans.CORPO_EMAIL;
	that.CKEDITOR_ID = parans.CKEDITOR_ID;
	that.TEMPLATE = parans.TEMPLATE;
	that.TIPO_ARQUIVO = parans.TIPO[0].VALOR;
	that.MODULO_EMAIL = parans.MODULO_EMAIL;
	if (typeof parans.TEMPLATE != 'undefined') {
		that.TEMPLATE_TIPO = parans.TEMPLATE[0].ID;
		that.CORPO_EMAIL = angular.copy(parans.TEMPLATE[0].TEMPLATE);
		that.ASSUNTO = angular.copy(parans.TEMPLATE[0].ASSUNTO);

		if (typeof parans.FNC_MUDAR_TEXTO_EMAIL == 'undefined') {
			that.FNC_MUDAR_TEXTO_EMAIL = function (model) {
				for (var index = 0; index < model.TEMPLATE.length; index++) {
					var item = model.TEMPLATE[index];
					if (item.ID == model.TEMPLATE_TIPO) {
						model.CORPO_EMAIL = angular.copy(item.TEMPLATE);
						model.ASSUNTO = angular.copy(item.ASSUNTO);
						CKEDITOR.instances[model.CKEDITOR_ID].setData(item.TEMPLATE);
						break;
					}
				}
			}
		} else {
			that.FNC_MUDAR_TEXTO_EMAIL = parans.FNC_MUDAR_TEXTO_EMAIL;
		}
	} else {
		that.TEMPLATE_TIPO = '';
	}


	if (typeof parans.CKEDITOR_CONFIG == 'undefined') {
		parans.CKEDITOR_CONFIG = {
			toolbar: [{
				name: "document",
				items: ["Print"]
			}, {
				name: "clipboard",
				items: ["Undo", "Redo"]
			}, {
				name: "styles",
				items: ["Format", "Font", "FontSize"]
			}, {
				name: "basicstyles",
				items: ["Bold", "Italic", "Underline", "Strike", "RemoveFormat", "CopyFormatting"]
			}, {
				name: "colors",
				items: ["TextColor", "BGColor"]
			}, {
				name: "align",
				items: ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"]
			}, {
				name: "links",
				items: ["Link", "Unlink"]
			}, {
				name: "paragraph",
				items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent", "-", "Blockquote"]
			}, {
				name: "insert",
				items: ["Table"]
			}],
			removePlugins: "autoembed,embedsemantic,image2,sourcedialog",
			disallowedContent: "img{width,height,float}",
			extraAllowedContent: "img[width,height,align]",
			bodyClass: "document-editor",
			height: 350
		};
	}

	var html = '';
	var str_file = '';
	var valido = true;
	if (typeof parans.FNC_VALIDAR == 'undefined') {
		valido = function () { return true; }
	} else {
		valido = parans.FNC_VALIDAR(that);
	}


	if (valido) {
		if (typeof parans.FNC_ONLOAD != 'undefined') {

		}

		if (typeof parans.FNC_HTML == 'undefined') {

			str_file = '<div class="itens-inputs" style="display: inline-flex;">'
				+ '  <div class="form-group" style="display: grid; width: 100px;">'
				+ '      <label>Arquivo:</label>'
				+ '      <select ng-model="' + that.MODEL_NAME + '.TIPO_ARQUIVO" class="tipe-file-send">';
			str_file = str_file + '  <option ng-repeat="item in ' + that.MODEL_NAME + '.TIPO track by $index" ng-value="item.VALOR">{{item.DESCRICAO}}</option>';
			str_file = str_file + '    </select>'
				+ '  </div>'
			if (typeof parans.TEMPLATE != 'undefined') {
				str_file = str_file + '<div class="form-group" style="display: grid; width: 100px; margin-left: 25px;">'
					+ '      <label>Template:</label>'
					+ '      <select ng-model="' + that.MODEL_NAME + '.TEMPLATE_TIPO" ng-change="' + that.MODEL_NAME + '.FNC_MUDAR_TEXTO_EMAIL(' + that.MODEL_NAME + ')" class="tipe-template">';
				str_file = str_file + '  <option ng-repeat="item in ' + that.MODEL_NAME + '.TEMPLATE track by $index" ng-value="item.ID">{{item.ID}} -  {{item.DESCRICAO}}</option>';

				str_file = str_file + '</select>'
					+ '  </div>';
			}

			str_file = str_file + '</div>';



			html = '<input type="text" style="display: none;" name="titulo" class="name-file-send" ng-model="' + that.MODEL_NAME + '.FILE_DATA" autocomplete="off">'
				+ '<input type="text" style="display: none;" name="titulo" class="table-file-send" value="" autocomplete="off">'
				+ str_file
				+ '<div class="row" style="height: calc(100vh - 320px);">'
				+ '<div class="itens-inputs">'
				+ '  <div class="form-group">'
				+ '      <label>Para:</label>'//ng-model="vm.EMAIL"
				+ '      <input type="text" style="width: 100% !important;text-transform: lowercase;" name="titulo" class="email-file-send form-control input-maior" ng-model="' + that.MODEL_NAME + '.EMAIL" autocomplete="off">'
				+ '  </div>'
				+ '</div>'

				+ '<div class="itens-inputs" style="display: inline-flex;">'
				+ '  <div class="form-group">'
				+ '      <label>Assunto:</label>' // ng-model="vm.ASSUNTO"
				+ '      <input type="text" style="width: 1400px !important;" maxlength="200" name="titulo" class="assunto-file-send form-control input-maior normal-case" ng-model="' + that.MODEL_NAME + '.ASSUNTO" autocomplete="off">'
				+ '  </div>'
				+ '</div>'
				+ '<div class="itens-inputs">'
				+ '    <div class="form-group">'
				+ '        <textarea id="corpo_file_send" class="form-control corpo-file-send normal-case" rows="9" cols="70" ng-model="' + that.MODEL_NAME + '.CORPO_EMAIL"></textarea>'
				+ '    </div>'
				+ '</div>'
				+ '</div>'
		} else {
			html = parans.FNC_HTML();
		}

		var a = gScope.Confirme.add(1, parans.TITULO_MODAL,
			html
			, [
				{ desc: 'Cancelar', class: 'btn-danger', ret: '2', hotkey: 'esc', glyphicon: 'glyphicon glyphicon-ban-circle' },
				{ desc: 'Enviar', class: 'btn-primary', ret: '1', hotkey: 'f1', glyphicon: 'glyphicon glyphicon-ok' },
			], [
			function (e, btn) {
				// Botão "Cancelar"
				a.alto_fechar = true;
			},
			function (e, btn) {
				// Botão "Enviar"
				that.CORPO_EMAIL = CKEDITOR.instances[that.CKEDITOR_ID].getData();
				//$timeout(function(){
				var email = that.EMAIL
				var asunto = that.ASSUNTO
				var corpo = that.CORPO_EMAIL;
				var name = $('.name-file-send').val();
				var file = name;
				var table = $('.table-file-send').val();
				var tipe = that.TIPO_ARQUIVO; //$('.tipe-file-send').val();
				var template = that.TEMPLATE_TIPO;
				var tabela = that.TABELA;
				var tabela_id = that.TABELA_ID;
				var historico_mensagem = '';
				var modulo_email = that.MODULO_EMAIL;

				//name = name.replace(urlhost,'');
				if (tipe == 'CSV') {
					file = ExcellentExport.csv(name, table);
				}

				if (tipe == 'XLS') {
					file = ExcellentExport.excel4(name, table);
				}

				file = file.replace(urlhost, '');
				var valido = true;
				if (typeof parans.FNC_VALIDAR_ENVIO == 'undefined') {
					valido = function () { return true; }
				} else {
					valido = parans.FNC_VALIDAR_ENVIO(that, parans);
				}

				if (valido) {
					a.alto_fechar = true;
					sendEmailFile(email, file, tipe, asunto, corpo, name, table, historico_mensagem, tabela, tabela_id, modulo_email).then(function () {
						showSuccess('Arquivo enviado por email.');
						if (typeof that.FNC_LOADEND != 'undefined') {
							that.FNC_LOADEND(parans);
						}
					});
				} else {
					showErro(parans.MSG_ERROR);
				}

				//})
			}
		]);

		if (typeof a.id != 'undefined') {
			var b = angular.element('#' + a.id).find('div.modal-dialog');
			if (b.length > 0) {
				angular.element(b).addClass(parans.MODAL_CLASS);
			}
		}
		a.alto_fechar = false;
		CKEDITOR.replace(parans.CKEDITOR_ID, parans.CKEDITOR_CONFIG);

	} else {
		showErro(parans.MSG_ERROR);
	}
}

/**
 * Função criada para focar o próximo editável do evento de gatilho
 * se acaso for uma consulta passar o parâmetro consulta como true.
 * @param {target} event
 * @param {boolean} consulta
 */
function findNextField(event, consulta) {
	if (consulta) {
		//se o alvo do evento for uma consulta...
		var a = $(event).nextAll();
	} else {
		//se o alvo do evento não for uma consulta...
		var a = $(event.currentTarget).nextAll();
	}

	for (var index = 0; index < a.length; index++) {
		var z = $(a[index]);
		if (z.is('div')) {
			var b = z.find('input:focusable:not(:disabled):not([readonly])');
			var c = z.find('select:focusable:not(:disabled):not([readonly])');
			var d = z.find('textarea:focusable:not(:disabled):not([readonly])');
			var e = z.find('div.consulta:not(' + event + ')');
			if (b.length > 0) {
				b.first().focus();
				b.first().select();
				break;
			} else if (c.length > 0) {
				c.first().focus();
				c.first().select();
				break;
			} else if (d.length > 0) {
				d.first().focus();
				d.first().select();
				break;
			} else if (e.length > 0) {
				if (e.find('button.btn-apagar-filtro-consulta:enabled')) {
					var x = e.find('input:focusable')
					if (x.length > 0) {
						e.find('input:focusable').first().focus();
						e.find('input:focusable').first().select();
						break;
					}
				}
			}
		} else {
			if (z.is('input:focusable:not(:disabled):not([readonly])')) {
				z.focus();
				z.select();
				break;
			} else if (z.is('select:focusable:not(:disabled):not([readonly])')) {
				z.focus();
				z.select();
				break;
			} else if (z.is('textarea:focusable:not(:disabled):not([readonly])')) {
				z.focus();
				z.select();
				break;
			}
		}
	}

	if (a.length == 0 && consulta == true) {
		var zw = $(event).parent().parent().nextAll();
		for (var index = 0; index < zw.length; index++) {
			var z = $(zw[index]);
			if (z.is('div')) {
				var b = z.find('input:focusable:not(:disabled):not([readonly])');
				var c = z.find('select:focusable:not(:disabled):not([readonly])');
				var d = z.find('textarea:focusable:not(:disabled):not([readonly])');
				if (b.length > 0) {
					b.first().focus();
					b.first().select();
					break;
				} else if (c.length > 0) {
					c.first().focus();
					c.first().select();
					break;
				} else if (d.length > 0) {
					d.first().focus();
					d.first().select();
					break;
				}
			} else {
				if (z.is('input:focusable:not(:disabled):not([readonly])')) {
					z.focus();
					z.select();
					break;
				} else if (z.is('select:focusable:not(:disabled):not([readonly])')) {
					z.focus();
					z.select();
					break;
				} else if (z.is('textarea:focusable:not(:disabled):not([readonly])')) {
					z.focus();
					z.select();
					break;
				}
			}
		}
	}
}

function getRandomColor() {
	var letters = '0123456789ABCDEF';
	var color = '#';
	for (var i = 0; i < 6; i++) {
		color += letters[Math.floor(Math.random() * 16)];
	}
	return color;
}

/**
 * Converte um código de cor HEX em RGB
 * Caso não seja passsado um HEX, será retornado uma cor aleatória
 * @param {string} hex
 * @param {number} alpha
 */
function hexToRGB(hex, alpha) {
	var rgba = '';

	if (trim_null(hex) == '') {
		hex = getRandomColor();
	}

	var r = parseInt(hex.slice(1, 3), 16);
	var g = parseInt(hex.slice(3, 5), 16);
	var b = parseInt(hex.slice(5, 7), 16);

	if (trim_null(alpha) != '') {
		rgba = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
	} else {
		rgba = 'rgba(' + r + ', ' + g + ', ' + b + ')';
	}

	return rgba;
}

/**
 * Converte um código de cor RGBa em HEX
 * Caso não seja passsado um RGBa válidi, será retornado uma cor aleatória
 * @param {number} r
 * @param {number} g
 * @param {number} b
 * @param {number} a 
 */
function rgbaToHex(r, g, b, a = 1) {

	if ((trim_null(r) == '' || trim_null(g) == '' || trim_null(b) == '')) {
		return;
	}

	var rh = r.toString(16);
	var gh = g.toString(16);
	var bh = b.toString(16);

	var ah = Math.round(a * 255).toString(16);

	rh.length == 1 ? "0" + rh : rh;
	gh.length == 1 ? "0" + gh : gh;
	bh.length == 1 ? "0" + bh : bh;

	ah.length == 1 ? "0" + ah : ah;

	return "#" + rh.padStart(2, '0') + gh.padStart(2, '0') + bh.padStart(2, '0') + ah;

}

/**
 * Verifica validade do valor HEX
 * @param {string} hex
 * @returns {boolean}
 */
const isValidHex = (hex) => /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex)

const getChunksFromString = (st, chunkSize) => st.match(new RegExp(`.{${chunkSize}}`, "g"))

const convertHexUnitTo256 = (hexStr) => parseInt(hexStr.repeat(2 / hexStr.length), 16)

const getAlphafloat = (a, alpha) => {
	if (typeof a !== "undefined") { return a / 255 }
	if ((typeof alpha != "number") || alpha < 0 || alpha > 1) {
		return 1
	}
	return alpha
}

function formatNumber2(number, decimals = 2, decimalSeparator = '.', thousandSeparator = ',') {
	if (isNaN(number) || isNaN(decimals) || decimals < 0) {
		return 'Invalid input';
	}

	const roundedNumber = Number(number.toFixed(decimals)).toLocaleString('en-US', {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	});

	const [integerPart, decimalPart] = roundedNumber.split('.');

	const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

	if (decimals === 0) {
		return formattedIntegerPart;
	} else {
		return `${formattedIntegerPart}${decimalSeparator}${decimalPart}`;
	}
}

/**
 * Converte qualquer código HEX válido em um objeto ou string RGBA.
 * @param {string} hex
 * @param {number} alpha
 * @param {boolean} onlyValues
 * @returns {object | string} 
 */
const anyHexToRGBA = (hex, alpha, onlyValues = true) => {
	if (!isValidHex(hex)) { throw new Error("Invalid HEX") }
	const chunkSize = Math.floor((hex.length - 1) / 3)
	const hexArr = getChunksFromString(hex.slice(1), chunkSize)
	const [r, g, b, a] = hexArr.map(convertHexUnitTo256)

	if (onlyValues) {

		var rgba = {
			RED: r,
			GREEN: g,
			BLUE: b,
			ALPHA: getAlphafloat(a, alpha)
		}

		return rgba;

	} else {

		return `rgba(${r}, ${g}, ${b}, ${getAlphafloat(a, alpha)})`;

	}
}

/**
 * Verifica a luminosidade da cor e define se ela é clara ou escura
 * Retorna Claro e Escuro
 * Em caso de Erro a função retorna Invalid Color 
 * @param {string} hex or Array Código Hexadecimal da Cor
 */
function verificaLuminosidade(hex) {
	hex = trim_null(hex);

	if (Array.isArray(hex)) {
		var array_ret = [];

		for (var i = 0; i < hex.length; i++) {
			var element = hex[i];
			var tam = 0;
			var lum = -1;
			var ret = '';

			element = trim_null(element.replace('#', ''));
			tam = element.length;

			if (tam > 3) {
				/* Código HEX Longo */
				var r = parseInt(hex.substr(0, 2), 16);
				var g = parseInt(hex.substr(2, 2), 16);
				var b = parseInt(hex.substr(4, 2), 16);

				lum = (r * 299 + g * 587 + b * 114) / 1000;

				if (lum > 128) {
					ret = 'Claro';
				} else {
					ret = 'Escuro';
				}
			} else if (tam == 3) {
				/* Código HEX Curto */
				var r = parseInt(hex.substr(0, 1), 16) * 17;
				var g = parseInt(hex.substr(1, 1), 16) * 17;
				var b = parseInt(hex.substr(2, 1), 16) * 17;

				lum = (r * 299 + g * 587 + b * 114) / 1000;

				if (lum > 128) {
					ret = 'Claro';
				} else {
					ret = 'Escuro';
				}
			} else {
				ret = 'Invalid Color';
			}

			array_ret.push(ret);
		}

		return array_ret;

	} else {
		var tam = 0;
		var lum = -1;
		var ret = '';

		hex = trim_null(hex.replace('#', ''));
		tam = hex.length;

		if (tam > 3) {
			/* Código HEX Longo */
			var r = parseInt(hex.substr(0, 2), 16);
			var g = parseInt(hex.substr(2, 2), 16);
			var b = parseInt(hex.substr(4, 2), 16);

			lum = (r * 299 + g * 587 + b * 114) / 1000;

			if (lum > 128) {
				ret = 'Claro';
			} else {
				ret = 'Escuro';
			}
		} else if (tam == 3) {
			/* Código HEX Curto */
			var r = parseInt(hex.substr(0, 1), 16) * 17;
			var g = parseInt(hex.substr(1, 1), 16) * 17;
			var b = parseInt(hex.substr(2, 1), 16) * 17;

			lum = (r * 299 + g * 587 + b * 114) / 1000;

			if (lum > 128) {
				ret = 'Claro';
			} else {
				ret = 'Escuro';
			}
		} else {
			ret = 'Invalid Color';
		}

		return ret;
	}
}

function getCountyCod() {

	return [
		{ COD: 93, DESCRICAO: ('93').padStart(2, '4') + ' - Afghanistan' }
		, { COD: 355, DESCRICAO: ('355').padStart(2, '4') + ' - Albania' }
		, { COD: 213, DESCRICAO: ('213').padStart(2, '4') + ' - Algeria' }
		, { COD: 684, DESCRICAO: ('684').padStart(2, '4') + ' - American Samoa' }
		, { COD: 376, DESCRICAO: ('376').padStart(2, '4') + ' - Andorra' }
		, { COD: 244, DESCRICAO: ('244').padStart(2, '4') + ' - Angola' }
		, { COD: 264, DESCRICAO: ('264').padStart(2, '4') + ' - Anguilla' }
		, { COD: 672, DESCRICAO: ('672').padStart(2, '4') + ' - Antarctica' }
		, { COD: 268, DESCRICAO: ('268').padStart(2, '4') + ' - Antigua and Barbuda' }
		, { COD: 54, DESCRICAO: ('54').padStart(2, '4') + ' - Argentina' }
		, { COD: 374, DESCRICAO: ('374').padStart(2, '4') + ' - Armenia' }
		, { COD: 297, DESCRICAO: ('297').padStart(2, '4') + ' - Aruba' }
		, { COD: 61, DESCRICAO: ('61').padStart(2, '4') + ' - Australia' }
		, { COD: 43, DESCRICAO: ('43').padStart(2, '4') + ' - Austria' }
		, { COD: 994, DESCRICAO: ('994').padStart(2, '4') + ' - Azerbaijan' }
		, { COD: 242, DESCRICAO: ('242').padStart(2, '4') + ' - Bahamas' }
		, { COD: 973, DESCRICAO: ('973').padStart(2, '4') + ' - Bahrain' }
		, { COD: 880, DESCRICAO: ('880').padStart(2, '4') + ' - Bangladesh' }
		, { COD: 246, DESCRICAO: ('246').padStart(2, '4') + ' - Barbados' }
		, { COD: 375, DESCRICAO: ('375').padStart(2, '4') + ' - Belarus' }
		, { COD: 32, DESCRICAO: ('32').padStart(2, '4') + ' - Belgium' }
		, { COD: 501, DESCRICAO: ('501').padStart(2, '4') + ' - Belize' }
		, { COD: 229, DESCRICAO: ('229').padStart(2, '4') + ' - Benin' }
		, { COD: 441, DESCRICAO: ('441').padStart(2, '4') + ' - Bermuda' }
		, { COD: 975, DESCRICAO: ('975').padStart(2, '4') + ' - Bhutan' }
		, { COD: 591, DESCRICAO: ('591').padStart(2, '4') + ' - Bolivia' }
		, { COD: 387, DESCRICAO: ('387').padStart(2, '4') + ' - Bosnia and Herzegovina' }
		, { COD: 267, DESCRICAO: ('267').padStart(2, '4') + ' - Botswana' }
		, { COD: 55, DESCRICAO: ('55').padStart(2, '4') + ' - Brasil' }
		, { COD: 246, DESCRICAO: ('246').padStart(2, '4') + ' - British Indian Ocean Territory' }
		, { COD: 284, DESCRICAO: ('284').padStart(2, '4') + ' - British Virgin Islands' }
		, { COD: 673, DESCRICAO: ('673').padStart(2, '4') + ' - Brunei' }
		, { COD: 359, DESCRICAO: ('359').padStart(2, '4') + ' - Bulgaria' }
		, { COD: 226, DESCRICAO: ('226').padStart(2, '4') + ' - Burkina Faso' }
		, { COD: 257, DESCRICAO: ('257').padStart(2, '4') + ' - Burundi' }
		, { COD: 855, DESCRICAO: ('855').padStart(2, '4') + ' - Cambodia' }
		, { COD: 237, DESCRICAO: ('237').padStart(2, '4') + ' - Cameroon' }
		, { COD: 1, DESCRICAO: ('1').padStart(2, '4') + ' - Canada' }
		, { COD: 238, DESCRICAO: ('238').padStart(2, '4') + ' - Cape Verde' }
		, { COD: 345, DESCRICAO: ('345').padStart(2, '4') + ' - Cayman Islands' }
		, { COD: 236, DESCRICAO: ('236').padStart(2, '4') + ' - Central African Republic' }
		, { COD: 235, DESCRICAO: ('235').padStart(2, '4') + ' - Chad' }
		, { COD: 56, DESCRICAO: ('56').padStart(2, '4') + ' - Chile' }
		, { COD: 86, DESCRICAO: ('86').padStart(2, '4') + ' - China' }
		, { COD: 61, DESCRICAO: ('61').padStart(2, '4') + ' - Christmas Island' }
		, { COD: 61, DESCRICAO: ('61').padStart(2, '4') + ' - Cocos Islands' }
		, { COD: 57, DESCRICAO: ('57').padStart(2, '4') + ' - Colombia' }
		, { COD: 269, DESCRICAO: ('269').padStart(2, '4') + ' - Comoros' }
		, { COD: 682, DESCRICAO: ('682').padStart(2, '4') + ' - Cook Islands' }
		, { COD: 506, DESCRICAO: ('506').padStart(2, '4') + ' - Costa Rica' }
		, { COD: 385, DESCRICAO: ('385').padStart(2, '4') + ' - Croatia' }
		, { COD: 53, DESCRICAO: ('53').padStart(2, '4') + ' - Cuba' }
		, { COD: 599, DESCRICAO: ('599').padStart(2, '4') + ' - Curacao' }
		, { COD: 357, DESCRICAO: ('357').padStart(2, '4') + ' - Cyprus' }
		, { COD: 420, DESCRICAO: ('420').padStart(2, '4') + ' - Czech Republic' }
		, { COD: 243, DESCRICAO: ('243').padStart(2, '4') + ' - Democratic Republic of the Congo' }
		, { COD: 45, DESCRICAO: ('45').padStart(2, '4') + ' - Denmark' }
		, { COD: 253, DESCRICAO: ('253').padStart(2, '4') + ' - Djibouti' }
		, { COD: 767, DESCRICAO: ('767').padStart(2, '4') + ' - Dominica' }
		, { COD: 809, DESCRICAO: ('809').padStart(2, '4') + ' - Dominican Republic' }
		, { COD: 670, DESCRICAO: ('670').padStart(2, '4') + ' - East Timor' }
		, { COD: 593, DESCRICAO: ('593').padStart(2, '4') + ' - Ecuador' }
		, { COD: 20, DESCRICAO: ('20').padStart(2, '4') + ' - Egypt' }
		, { COD: 503, DESCRICAO: ('503').padStart(2, '4') + ' - El Salvador' }
		, { COD: 240, DESCRICAO: ('240').padStart(2, '4') + ' - Equatorial Guinea' }
		, { COD: 291, DESCRICAO: ('291').padStart(2, '4') + ' - Eritrea' }
		, { COD: 372, DESCRICAO: ('372').padStart(2, '4') + ' - Estonia' }
		, { COD: 251, DESCRICAO: ('251').padStart(2, '4') + ' - Ethiopia' }
		, { COD: 500, DESCRICAO: ('500').padStart(2, '4') + ' - Falkland Islands' }
		, { COD: 298, DESCRICAO: ('298').padStart(2, '4') + ' - Faroe Islands' }
		, { COD: 679, DESCRICAO: ('679').padStart(2, '4') + ' - Fiji' }
		, { COD: 358, DESCRICAO: ('358').padStart(2, '4') + ' - Finland' }
		, { COD: 33, DESCRICAO: ('33').padStart(2, '4') + ' - France' }
		, { COD: 689, DESCRICAO: ('689').padStart(2, '4') + ' - French Polynesia' }
		, { COD: 241, DESCRICAO: ('241').padStart(2, '4') + ' - Gabon' }
		, { COD: 220, DESCRICAO: ('220').padStart(2, '4') + ' - Gambia' }
		, { COD: 995, DESCRICAO: ('995').padStart(2, '4') + ' - Georgia' }
		, { COD: 49, DESCRICAO: ('49').padStart(2, '4') + ' - Germany' }
		, { COD: 233, DESCRICAO: ('233').padStart(2, '4') + ' - Ghana' }
		, { COD: 350, DESCRICAO: ('350').padStart(2, '4') + ' - Gibraltar' }
		, { COD: 30, DESCRICAO: ('30').padStart(2, '4') + ' - Greece' }
		, { COD: 299, DESCRICAO: ('299').padStart(2, '4') + ' - Greenland' }
		, { COD: 473, DESCRICAO: ('473').padStart(2, '4') + ' - Grenada' }
		, { COD: 671, DESCRICAO: ('671').padStart(2, '4') + ' - Guam' }
		, { COD: 502, DESCRICAO: ('502').padStart(2, '4') + ' - Guatemala' }
		, { COD: 44, DESCRICAO: ('1481').padStart(2, '4') + ' - Guernsey' }
		, { COD: 224, DESCRICAO: ('224').padStart(2, '4') + ' - Guinea' }
		, { COD: 245, DESCRICAO: ('245').padStart(2, '4') + ' - Guinea-Bissau' }
		, { COD: 592, DESCRICAO: ('592').padStart(2, '4') + ' - Guyana' }
		, { COD: 509, DESCRICAO: ('509').padStart(2, '4') + ' - Haiti' }
		, { COD: 504, DESCRICAO: ('504').padStart(2, '4') + ' - Honduras' }
		, { COD: 852, DESCRICAO: ('852').padStart(2, '4') + ' - Hong Kong' }
		, { COD: 36, DESCRICAO: ('36').padStart(2, '4') + ' - Hungary' }
		, { COD: 354, DESCRICAO: ('354').padStart(2, '4') + ' - Iceland' }
		, { COD: 91, DESCRICAO: ('91').padStart(2, '4') + ' - India' }
		, { COD: 62, DESCRICAO: ('62').padStart(2, '4') + ' - Indonesia' }
		, { COD: 98, DESCRICAO: ('98').padStart(2, '4') + ' - Iran' }
		, { COD: 964, DESCRICAO: ('964').padStart(2, '4') + ' - Iraq' }
		, { COD: 353, DESCRICAO: ('353').padStart(2, '4') + ' - Ireland' }
		, { COD: 44, DESCRICAO: ('1624').padStart(2, '4') + ' - Isle of Man' }
		, { COD: 972, DESCRICAO: ('972').padStart(2, '4') + ' - Israel' }
		, { COD: 39, DESCRICAO: ('39').padStart(2, '4') + ' - Italy' }
		, { COD: 225, DESCRICAO: ('225').padStart(2, '4') + ' - Ivory Coast' }
		, { COD: 876, DESCRICAO: ('876').padStart(2, '4') + ' - Jamaica' }
		, { COD: 81, DESCRICAO: ('81').padStart(2, '4') + ' - Japan' }
		, { COD: 44, DESCRICAO: ('1534').padStart(2, '4') + ' - Jersey' }
		, { COD: 962, DESCRICAO: ('962').padStart(2, '4') + ' - Jordan' }
		, { COD: 7, DESCRICAO: ('7').padStart(2, '4') + ' - Kazakhstan' }
		, { COD: 254, DESCRICAO: ('254').padStart(2, '4') + ' - Kenya' }
		, { COD: 686, DESCRICAO: ('686').padStart(2, '4') + ' - Kiribati' }
		, { COD: 383, DESCRICAO: ('383').padStart(2, '4') + ' - Kosovo' }
		, { COD: 965, DESCRICAO: ('965').padStart(2, '4') + ' - Kuwait' }
		, { COD: 996, DESCRICAO: ('996').padStart(2, '4') + ' - Kyrgyzstan' }
		, { COD: 856, DESCRICAO: ('856').padStart(2, '4') + ' - Laos' }
		, { COD: 371, DESCRICAO: ('371').padStart(2, '4') + ' - Latvia' }
		, { COD: 961, DESCRICAO: ('961').padStart(2, '4') + ' - Lebanon' }
		, { COD: 266, DESCRICAO: ('266').padStart(2, '4') + ' - Lesotho' }
		, { COD: 231, DESCRICAO: ('231').padStart(2, '4') + ' - Liberia' }
		, { COD: 218, DESCRICAO: ('218').padStart(2, '4') + ' - Libya' }
		, { COD: 423, DESCRICAO: ('423').padStart(2, '4') + ' - Liechtenstein' }
		, { COD: 370, DESCRICAO: ('370').padStart(2, '4') + ' - Lithuania' }
		, { COD: 352, DESCRICAO: ('352').padStart(2, '4') + ' - Luxembourg' }
		, { COD: 853, DESCRICAO: ('853').padStart(2, '4') + ' - Macau' }
		, { COD: 389, DESCRICAO: ('389').padStart(2, '4') + ' - Macedonia' }
		, { COD: 261, DESCRICAO: ('261').padStart(2, '4') + ' - Madagascar' }
		, { COD: 265, DESCRICAO: ('265').padStart(2, '4') + ' - Malawi' }
		, { COD: 60, DESCRICAO: ('60').padStart(2, '4') + ' - Malaysia' }
		, { COD: 960, DESCRICAO: ('960').padStart(2, '4') + ' - Maldives' }
		, { COD: 223, DESCRICAO: ('223').padStart(2, '4') + ' - Mali' }
		, { COD: 356, DESCRICAO: ('356').padStart(2, '4') + ' - Malta' }
		, { COD: 692, DESCRICAO: ('692').padStart(2, '4') + ' - Marshall Islands' }
		, { COD: 222, DESCRICAO: ('222').padStart(2, '4') + ' - Mauritania' }
		, { COD: 230, DESCRICAO: ('230').padStart(2, '4') + ' - Mauritius' }
		, { COD: 262, DESCRICAO: ('262').padStart(2, '4') + ' - Mayotte' }
		, { COD: 52, DESCRICAO: ('52').padStart(2, '4') + ' - Mexico' }
		, { COD: 691, DESCRICAO: ('691').padStart(2, '4') + ' - Micronesia' }
		, { COD: 373, DESCRICAO: ('373').padStart(2, '4') + ' - Moldova' }
		, { COD: 377, DESCRICAO: ('377').padStart(2, '4') + ' - Monaco' }
		, { COD: 976, DESCRICAO: ('976').padStart(2, '4') + ' - Mongolia' }
		, { COD: 382, DESCRICAO: ('382').padStart(2, '4') + ' - Montenegro' }
		, { COD: 664, DESCRICAO: ('664').padStart(2, '4') + ' - Montserrat' }
		, { COD: 212, DESCRICAO: ('212').padStart(2, '4') + ' - Morocco' }
		, { COD: 258, DESCRICAO: ('258').padStart(2, '4') + ' - Mozambique' }
		, { COD: 95, DESCRICAO: ('95').padStart(2, '4') + ' - Myanmar' }
		, { COD: 264, DESCRICAO: ('264').padStart(2, '4') + ' - Namibia' }
		, { COD: 674, DESCRICAO: ('674').padStart(2, '4') + ' - Nauru' }
		, { COD: 977, DESCRICAO: ('977').padStart(2, '4') + ' - Nepal' }
		, { COD: 31, DESCRICAO: ('31').padStart(2, '4') + ' - Netherlands' }
		, { COD: 599, DESCRICAO: ('599').padStart(2, '4') + ' - Netherlands Antilles' }
		, { COD: 687, DESCRICAO: ('687').padStart(2, '4') + ' - New Caledonia' }
		, { COD: 64, DESCRICAO: ('64').padStart(2, '4') + ' - New Zealand' }
		, { COD: 505, DESCRICAO: ('505').padStart(2, '4') + ' - Nicaragua' }
		, { COD: 227, DESCRICAO: ('227').padStart(2, '4') + ' - Niger' }
		, { COD: 234, DESCRICAO: ('234').padStart(2, '4') + ' - Nigeria' }
		, { COD: 683, DESCRICAO: ('683').padStart(2, '4') + ' - Niue' }
		, { COD: 850, DESCRICAO: ('850').padStart(2, '4') + ' - North Korea' }
		, { COD: 670, DESCRICAO: ('670').padStart(2, '4') + ' - Northern Mariana Islands' }
		, { COD: 47, DESCRICAO: ('47').padStart(2, '4') + ' - Norway' }
		, { COD: 968, DESCRICAO: ('968').padStart(2, '4') + ' - Oman' }
		, { COD: 92, DESCRICAO: ('92').padStart(2, '4') + ' - Pakistan' }
		, { COD: 680, DESCRICAO: ('680').padStart(2, '4') + ' - Palau' }
		, { COD: 970, DESCRICAO: ('970').padStart(2, '4') + ' - Palestine' }
		, { COD: 507, DESCRICAO: ('507').padStart(2, '4') + ' - Panama' }
		, { COD: 675, DESCRICAO: ('675').padStart(2, '4') + ' - Papua New Guinea' }
		, { COD: 595, DESCRICAO: ('595').padStart(2, '4') + ' - Paraguay' }
		, { COD: 51, DESCRICAO: ('51').padStart(2, '4') + ' - Peru' }
		, { COD: 63, DESCRICAO: ('63').padStart(2, '4') + ' - Philippines' }
		, { COD: 64, DESCRICAO: ('64').padStart(2, '4') + ' - Pitcairn' }
		, { COD: 48, DESCRICAO: ('48').padStart(2, '4') + ' - Poland' }
		, { COD: 351, DESCRICAO: ('351').padStart(2, '4') + ' - Portugal' }
		, { COD: 787, DESCRICAO: ('787').padStart(2, '4') + ' - Puerto Rico' }
		, { COD: 974, DESCRICAO: ('974').padStart(2, '4') + ' - Qatar' }
		, { COD: 242, DESCRICAO: ('242').padStart(2, '4') + ' - Republic of the Congo' }
		, { COD: 262, DESCRICAO: ('262').padStart(2, '4') + ' - Reunion' }
		, { COD: 40, DESCRICAO: ('40').padStart(2, '4') + ' - Romania' }
		, { COD: 7, DESCRICAO: ('7').padStart(2, '4') + ' - Russia' }
		, { COD: 250, DESCRICAO: ('250').padStart(2, '4') + ' - Rwanda' }
		, { COD: 590, DESCRICAO: ('590').padStart(2, '4') + ' - Saint Barthelemy' }
		, { COD: 290, DESCRICAO: ('290').padStart(2, '4') + ' - Saint Helena' }
		, { COD: 869, DESCRICAO: ('869').padStart(2, '4') + ' - Saint Kitts and Nevis' }
		, { COD: 758, DESCRICAO: ('758').padStart(2, '4') + ' - Saint Lucia' }
		, { COD: 590, DESCRICAO: ('590').padStart(2, '4') + ' - Saint Martin' }
		, { COD: 508, DESCRICAO: ('508').padStart(2, '4') + ' - Saint Pierre and Miquelon' }
		, { COD: 784, DESCRICAO: ('784').padStart(2, '4') + ' - Saint Vincen t and the Grenadines' }
		, { COD: 685, DESCRICAO: ('685').padStart(2, '4') + ' - Samoa' }
		, { COD: 378, DESCRICAO: ('378').padStart(2, '4') + ' - San Marino' }
		, { COD: 239, DESCRICAO: ('239').padStart(2, '4') + ' - Sao Tome and Principe' }
		, { COD: 966, DESCRICAO: ('966').padStart(2, '4') + ' - Saudi Arabia' }
		, { COD: 221, DESCRICAO: ('221').padStart(2, '4') + ' - Senegal' }
		, { COD: 381, DESCRICAO: ('381').padStart(2, '4') + ' - Serbia' }
		, { COD: 248, DESCRICAO: ('248').padStart(2, '4') + ' - Seychelles' }
		, { COD: 232, DESCRICAO: ('232').padStart(2, '4') + ' - Sierra Leone' }
		, { COD: 65, DESCRICAO: ('65').padStart(2, '4') + ' - Singapore' }
		, { COD: 721, DESCRICAO: ('721').padStart(2, '4') + ' - Sint Maarten' }
		, { COD: 421, DESCRICAO: ('421').padStart(2, '4') + ' - Slovakia' }
		, { COD: 386, DESCRICAO: ('386').padStart(2, '4') + ' - Slovenia' }
		, { COD: 677, DESCRICAO: ('677').padStart(2, '4') + ' - Solomon Islands' }
		, { COD: 252, DESCRICAO: ('252').padStart(2, '4') + ' - Somalia' }
		, { COD: 27, DESCRICAO: ('27').padStart(2, '4') + ' - South Africa' }
		, { COD: 82, DESCRICAO: ('82').padStart(2, '4') + ' - South Korea' }
		, { COD: 211, DESCRICAO: ('211').padStart(2, '4') + ' - South Sudan' }
		, { COD: 34, DESCRICAO: ('34').padStart(2, '4') + ' - Spain' }
		, { COD: 94, DESCRICAO: ('94').padStart(2, '4') + ' - Sri Lanka' }
		, { COD: 249, DESCRICAO: ('249').padStart(2, '4') + ' - Sudan' }
		, { COD: 597, DESCRICAO: ('597').padStart(2, '4') + ' - Suriname' }
		, { COD: 47, DESCRICAO: ('47').padStart(2, '4') + ' - Svalbard and Jan Mayen' }
		, { COD: 268, DESCRICAO: ('268').padStart(2, '4') + ' - Swaziland' }
		, { COD: 46, DESCRICAO: ('46').padStart(2, '4') + ' - Sweden' }
		, { COD: 41, DESCRICAO: ('41').padStart(2, '4') + ' - Switzerland' }
		, { COD: 963, DESCRICAO: ('963').padStart(2, '4') + ' - Syria' }
		, { COD: 886, DESCRICAO: ('886').padStart(2, '4') + ' - Taiwan' }
		, { COD: 992, DESCRICAO: ('992').padStart(2, '4') + ' - Tajikistan' }
		, { COD: 255, DESCRICAO: ('255').padStart(2, '4') + ' - Tanzania' }
		, { COD: 66, DESCRICAO: ('66').padStart(2, '4') + ' - Thailand' }
		, { COD: 228, DESCRICAO: ('228').padStart(2, '4') + ' - Togo' }
		, { COD: 690, DESCRICAO: ('690').padStart(2, '4') + ' - Tokelau' }
		, { COD: 676, DESCRICAO: ('676').padStart(2, '4') + ' - Tonga' }
		, { COD: 868, DESCRICAO: ('868').padStart(2, '4') + ' - Trinidad and Tobago' }
		, { COD: 216, DESCRICAO: ('216').padStart(2, '4') + ' - Tunisia' }
		, { COD: 90, DESCRICAO: ('90').padStart(2, '4') + ' - Turkey' }
		, { COD: 993, DESCRICAO: ('993').padStart(2, '4') + ' - Turkmenistan' }
		, { COD: 649, DESCRICAO: ('649').padStart(2, '4') + ' - Turks and Caicos Islands' }
		, { COD: 688, DESCRICAO: ('688').padStart(2, '4') + ' - Tuvalu' }
		, { COD: 340, DESCRICAO: ('340').padStart(2, '4') + ' - U.S. Virgin Islands' }
		, { COD: 256, DESCRICAO: ('256').padStart(2, '4') + ' - Uganda' }
		, { COD: 380, DESCRICAO: ('380').padStart(2, '4') + ' - Ukraine' }
		, { COD: 971, DESCRICAO: ('971').padStart(2, '4') + ' - United Arab Emirates' }
		, { COD: 44, DESCRICAO: ('44').padStart(2, '4') + ' - United Kingdom' }
		, { COD: 1, DESCRICAO: ('1').padStart(2, '4') + ' - United States' }
		, { COD: 598, DESCRICAO: ('598').padStart(2, '4') + ' - Uruguay' }
		, { COD: 998, DESCRICAO: ('998').padStart(2, '4') + ' - Uzbekistan' }
		, { COD: 678, DESCRICAO: ('678').padStart(2, '4') + ' - Vanuatu' }
		, { COD: 379, DESCRICAO: ('379').padStart(2, '4') + ' - Vatican' }
		, { COD: 58, DESCRICAO: ('58').padStart(2, '4') + ' - Venezuela' }
		, { COD: 84, DESCRICAO: ('84').padStart(2, '4') + ' - Vietnam' }
		, { COD: 681, DESCRICAO: ('681').padStart(2, '4') + ' - Wallis and Futuna' }
		, { COD: 212, DESCRICAO: ('212').padStart(2, '4') + ' - Western Sahara' }
		, { COD: 967, DESCRICAO: ('967').padStart(2, '4') + ' - Yemen' }
		, { COD: 260, DESCRICAO: ('260').padStart(2, '4') + ' - Zambia' }
		, { COD: 263, DESCRICAO: ('263').padStart(2, '4') + ' - Zimbabwe' }
	];
}
function LightColors(i) {
	var color = [
		'#F0F8FF',
		'#F8F8FF',
		'#FFFAFA',
		'#FFF5EE',
		'#FFFAF0',
		'#F5F5F5',
		'#F5F5DC',
		'#FDF5E6',
		'#FFFFF0',
		'#FAF0E6',
		'#FFF8DC',
		'#FAEBD7',
		'#FFEBCD',
		'#FFE4C4',
		'#FFFFE0',
		'#FFFACD',
		'#FAFAD2',
		'#FFEFD5',
		'#FFDAB9',
		'#FFE4B5',
		'#EEE8AA',
		'#FFE4E1',
		'#FFF0F5',
		'#E6E6FA',
		'#D8BFD8',
		'#F0FFFF',
		'#E0FFFF',
		'#B0E0E6',
		'#E0FFFF',
		'#F0FFF0',
		'#F5FFFA',
		'#F0F8FF',
		'#F8F8FF',
		'#FFFAFA',
		'#FFF5EE',
		'#FFFAF0',
		'#F5F5F5',
		'#F5F5DC',
		'#FDF5E6',
		'#FFFFF0',
		'#FAF0E6',
		'#FFF8DC',
		'#FAEBD7',
		'#FFEBCD',
		'#FFE4C4',
		'#FFFFE0',
		'#FFFACD',
		'#FAFAD2',
		'#FFEFD5',
		'#FFDAB9',
		'#FFE4B5',
		'#EEE8AA',
		'#FFE4E1',
		'#FFF0F5',
		'#E6E6FA',
		'#D8BFD8',
		'#F0FFFF',
		'#E0FFFF',
		'#B0E0E6',
		'#E0FFFF',
		'#F0FFF0',
		'#F5FFFA',
		'#F0F8FF',
		'#F8F8FF',
		'#FFFAFA',
		'#FFF5EE',
		'#FFFAF0',
		'#F5F5F5',
		'#F5F5DC',
		'#FDF5E6',
		'#FFFFF0',
		'#FAF0E6',
		'#FFF8DC',
		'#FAEBD7',
		'#FFEBCD',
		'#FFE4C4',
		'#FFFFE0',
		'#FFFACD',
		'#FAFAD2',
		'#FFEFD5',
		'#FFDAB9',
		'#FFE4B5',
		'#EEE8AA',
		'#FFE4E1',
		'#FFF0F5',
		'#E6E6FA',
		'#D8BFD8',
		'#F0FFFF',
		'#E0FFFF',
		'#B0E0E6',
		'#E0FFFF',
		'#F0FFF0',
		'#F5FFFA',
		'#F0F8FF',
		'#F8F8FF',
		'#FFFAFA',
		'#FFF5EE',
		'#FFFAF0',
		'#F5F5F5',
		'#F5F5DC',
	];

	return color[i];
}

function startOfMonth(mes) {
	var data = moment().format((mes + '').padStart(2, '0') + '/01/YYYY');
	return moment(data).date(1).toDate();
}

function endOfMonth(mes) {
	var data = moment().format((mes + '').padStart(2, '0') + '/01/YYYY');
	var qtd_dias = diasMes(moment(data).toDate());
	return moment(data).date(qtd_dias).toDate();
}

function getDate() {
	return moment().toDate();
}

function getIniMes() {
	return moment().date(1).toDate();
}

function getFimMes() {
	var qtd_dias = diasMes(moment().toDate());
	return moment().date(qtd_dias).toDate();
}

function numDiasMes(mes, ano) {
	numDias = new Date(ano, mes + 1, 0).getDate();
	return numDias;
}

function diasMes(date) {
	var ano = date.getFullYear();
	var mes = date.getMonth();
	numDias = new Date(ano, mes + 1, 0).getDate();
	return numDias;
}

function getDiasUteis(startDate, endDate, qtd) {
	var numDiasUteis = 0;
	var arrayDiasUteis = [];
	var diaInicial = new Date(startDate);
	while (diaInicial <= endDate) {
		// Skips Sunday and Saturday
		if (diaInicial.getDay() !== 0 && diaInicial.getDay() !== 6) {
			numDiasUteis++;
			arrayDiasUteis.push(diaInicial);
		}
		diaInicial = diaInicial.addDays(1);
	}
	if (typeof qtd != 'undefined') {
		return numDiasUteis;
	} else {
		return arrayDiasUteis;
	}
}

/**
 * Função criada para validar a data informada
 * se acaso a data for válida retorna true.
 * @param {data} date
 */
function isValidDate(data) {
	return data instanceof Date && !isNaN(data);
}

/**
 * Função criada para buscar os dias entre duas datas informadas
 * @param {data} startDate data inicial
 * @param {data} stopDate data final
 */
function getDatesinPeriod(startDate, stopDate) {
	var dateArray = new Array();
	var currentDate = startDate;
	while (currentDate <= stopDate) {
		dateArray.push(new Date(currentDate));
		currentDate = currentDate.addDays(1);
	}
	return dateArray;
}
/**
 * Função criada para buscar os meses entre duas datas informadas
 * @param {data} startDate data inicial
 * @param {data} stopDate data final
 */
function getMonthsinPeriod(startDate, stopDate) {
	var months = undefined;
	months = (stopDate.getFullYear() - startDate.getFullYear()) * 12;
	months -= startDate.getMonth();
	months += stopDate.getMonth();
	return months <= 0 ? 0 : months;
}

/**
 * Função criada para buscar os anos entre duas datas informadas
 * @param {data} startDate data inicial
 * @param {data} stopDate data final
 */
function getYearsinPeriod(startDate, stopDate) {
	var diffYear = (stopDate.getTime() - startDate.getTime()) / 1000;
	diffYear /= (60 * 60 * 24);
	return Math.abs(Math.round(diffYear / 365.25));

}

Object.defineProperty(Array.prototype, 'orderBy', {
	value: function (sorts) {
		sorts.map(sort => {
			sort.uniques = Array.from(
				new Set(this.map(obj => obj[sort.key]))
			);

			sort.uniques = sort.uniques.sort((a, b) => {
				if (typeof a == 'string') {
					return sort.inverse ? b.localeCompare(a) : a.localeCompare(b);
				}
				else if (typeof a == 'number') {
					return sort.inverse ? b - a : a - b;
				}
				else if (typeof a == 'boolean') {
					let x = sort.inverse ? (a === b) ? 0 : a ? -1 : 1 : (a === b) ? 0 : a ? 1 : -1;
					return x;
				}
				return 0;
			});
		});

		const weightOfObject = (obj) => {
			let weight = "";
			sorts.map(sort => {
				let zeropad = `${sort.uniques.length}`.length;
				weight += sort.uniques.indexOf(obj[sort.key]).toString().padStart(zeropad, '0');
			});
			//obj.weight = weight; // if you need to see weights
			return weight;
		}

		this.sort((a, b) => {
			return weightOfObject(a).localeCompare(weightOfObject(b));
		});

		return this;
	}
});

Date.prototype.addDays = function (days) {
	var date = new Date(this.valueOf());
	date.setDate(date.getDate() + days);
	return date;
}

Date.prototype.addMonth = function (months) {
	var date = new Date(this.valueOf());
	date.setMonth(date.getMonth() + months);
	return date;
}

Date.prototype.addYear = function (years) {
	var date = new Date(this.valueOf());
	date.setFullYear(date.getFullYear() + years);
	return date;
}

Date.prototype.aplyUTC = function () {
	var date = new Date(this.valueOf());
	var now1 = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), 0);
	return new Date(now1.getTime() - now1.getTimezoneOffset() * 60000).toISOString().substring(0, 19);
}

Date.prototype.DateFormat = function () {
	var date = new Date(this.valueOf());
	return date.getUTCFullYear() + '.' + (date.getUTCMonth() + 1) + '.' + date.getUTCDate();
}

Date.prototype.DateTimeFormat = function () {
	var date = new Date(this.valueOf());
	return date.getUTCFullYear() + '.' + (date.getUTCMonth() + 1) + '.' + date.getUTCDate() + ' ' + date.getUTCHours() + ':' + date.getUTCMinutes();
}

Date.prototype.aplyHour = function (hora, minuto, segundo) {
	var date = new Date(this.valueOf());
	var now1 = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), hora, minuto, segundo);
	return new Date(now1.getTime());
}

Date.prototype.aplyMinutes = function (minuto, segundo) {
	var date = new Date(this.valueOf());
	var now1 = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getHours, minuto, segundo);
	return new Date(now1.getTime());
}

Date.prototype.isValidDate = function () {
	return true;
}

String.prototype.isValidDate = function () {
	return false;
}

var dataConfig = {
	Timezone: 'GMT-0300',
	monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
	monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
	dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sabado'],
	dayNamesFeira: ['Domingo', 'Segunda-Feira', 'Terça-Feira', 'Quarta-Feira', 'Quinta-Feira', 'Sexta-Feira', 'Sabado'],
	dayNames2: ['.', 'Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sabado'],
	dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
	dayNamesShort2: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
}

var ObjIsEquals = function (object1, object2) {
	// Realiza a verificação das propriedades dos objetos.
	var prop1 = Object.getOwnPropertyNames(object1);
	var prop2 = Object.getOwnPropertyNames(object1);

	// Realiza a verificação se ambos objetos possuem o mesmo número de 
	// propriedades. Caso contrário, já retorna dizendo que são diferentes.
	if (prop1.length !== prop2.length)
		return false;

	// Aqui, está sendo verificado se o objeto possui alguma propriedade.
	// Será usado quando for chamada a função na sua forma recursiva,
	// para verificar valores literais.
	if (prop1.length === 0)
		if (object1 === object2)
			return true;
		else
			return false;

	// Se forem iguais, realiza uma iteração por todas as propriedades.
	for (var i = 0; i < prop1.length; i++) {
		// Guarda o valor da propriedade atual na variável "prop".
		var prop = prop1[i];

		// Aqui está o pulo do gato.
		// Verifica se o valor e o tipo das duas propriedades são iguais.
		// Se sim, somente pula para a próxima iteração. Caso contrário,
		// podem ser duas coisas: ou são realmente distintos, ou é um objeto,
		// que, ao comparar as referências, retorna sempre falso.
		// Para ter certeza da informação, é chamada a mesma função de forma
		// recursiva, mandando, por parâmetro, os dois objetos que ficou a dúvida.
		// Se forem iguais, ou se tiverem mais algum objeto internamente, 
		// a função continuará a ser chamada recursivamente, até chegar ao
		// ponto de ser um valor literal. Ou, então, retornará falso, pois não
		// são iguais.
		// Caso sejam iguais, a função só continuará para a próxima iteração.
		// Caso contrário, a função já informa que não são dois objetos iguais.
		if (object1[prop] !== object2[prop]) {
			if (ObjIsEquals(object1[prop], object2[prop]))
				continue;
			else
				return false;
		}
	}
	// Se chegou até aqui e aguentou todas as verificações...
	// Os objetos são iguais!
	return true;
}

/**
 * Função criada para converter uma string de array de JSON's em um array de objetos 
 * @param {string} string string de array para conversão
 * @param {string} sep seprador que será utilizado para quebar a string de array
 * @param {number} index seleciona um indice em específico do array. Caso o indice não exita, retorna o array completo
 * 
 * @returns {array} retorna array de objetos caso index seja nulo/indefinido
 * @returns {object} retorna objeto caso index seja definido
 */
function converterArrayJson(string, sep, index = null) {
	if (trim_null(string) != '' && trim_null(sep) != '') {

		var array = [], str_format = [];

		str_format = string.split(trim_null(sep));

		for (var key = 0; key < str_format.length; key++) {
			var value = str_format[key];

			value = JSON.parse(value);

			array.push(angular.copy(value));
		}

		if (trim_null(index) != '') {
			if (index < 0 || index > (array.length - 1)) {
				return array;
			} else {
				return array[index];
			}
		} else {
			return array;
		}

	} else {
		showError('Parâmetros da função não definidos!');
		return null;
	}
}

//console.log('ta mec 2');
/**
 * Função criada para remover duplicatas de arrays multidimensionais
 * sendo: originalArray o array a ser tratato, prop o campo identificador
 */
function removeArrayDuplicates(originalArray, prop) {
	var newArray = [];
	var lookupObject = {};

	for (var i in originalArray) {
		lookupObject[originalArray[i][prop]] = originalArray[i];
	}

	for (i in lookupObject) {
		newArray.push(lookupObject[i]);
	}
	return newArray;
}

/**
 * Função criada para remover encontrar números faltantes em um array sequencial
 * sendo: array o array a ser tratato.
 */
function findMissingNumber(array) {
	var missing;
	for (var i = 1; i <= array.length; i++) {
		if (array[i - 1] != i) {
			missing = i;
			return missing;
			break;
		}
	}
}

function isMobile() {
	var userAgent = navigator.userAgent.toLowerCase();
	//console.log('Navegador utilizado',userAgent);
	//alert('Navegador utilizado',userAgent);
	if (userAgent.search(/(android|avantgo|blackberry|bolt|boost|cricket|docomo|fone|hiptop|mini|mobi|palm|phone|pie|tablet|up\.browser|up\.link|webos|wos)/i) != -1) {
		return true;
	}
}

function isMobileDevice() {
	let check = false;

	(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	
	return check;
}

/**
 * Função criada para escrever por extenso um valor contábil
 * sendo: c - valor a ser escrito por extenso.
 */
function NumberExtenso(c) {
	var ex = [
		["zero", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove", "dez", "onze", "doze", "treze", "quatorze", "quinze", "dezesseis", "dezessete", "dezoito", "dezenove"],
		["dez", "vinte", "trinta", "quarenta", "cinqüenta", "sessenta", "setenta", "oitenta", "noventa"],
		["cem", "cento", "duzentos", "trezentos", "quatrocentos", "quinhentos", "seiscentos", "setecentos", "oitocentos", "novecentos"],
		["mil", "milhão", "bilhão", "trilhão", "quadrilhão", "quintilhão", "sextilhão", "setilhão", "octilhão", "nonilhão", "decilhão", "undecilhão", "dodecilhão", "tredecilhão", "quatrodecilhão", "quindecilhão", "sedecilhão", "septendecilhão", "octencilhão", "nonencilhão"]
	];
	var a, n, v, i, n = c.replace(c ? /[^,\d]/g : /\D/g, "").split(","), e = " e ", $ = "real", d = "centavo", sl;
	for (var f = n.length - 1, l, j = -1, r = [], s = [], t = ""; ++j <= f; s = []) {
		j && (n[j] = (("." + n[j]) * 1).toFixed(2).slice(2));
		if (!(a = (v = n[j]).slice((l = v.length) % 3).match(/\d{3}/g), v = l % 3 ? [v.slice(0, l % 3)] : [], v = a ? v.concat(a) : v).length) continue;
		for (a = -1, l = v.length; ++a < l; t = "") {
			if (!(i = v[a] * 1)) continue;
			i % 100 < 20 && (t += ex[0][i % 100]) ||
				i % 100 + 1 && (t += ex[1][(i % 100 / 10 >> 0) - 1] + (i % 10 ? e + ex[0][i % 10] : ""));
			s.push((i < 100 ? t : !(i % 100) ? ex[2][i == 100 ? 0 : i / 100 >> 0] : (ex[2][i / 100 >> 0] + e + t)) +
				((t = l - a - 2) > -1 ? " " + (i > 1 && t > 0 ? ex[3][t].replace("ão", "ões") : ex[3][t]) : ""));
		}
		a = ((sl = s.length) > 1 ? (a = s.pop(), s.join(" ") + e + a) : s.join("") || ((!j && (n[j + 1] * 1 > 0) || r.length) ? "" : ex[0][0]));
		a && r.push(a + (c ? (" " + (v.join("") * 1 > 1 ? j ? d + "s" : (/0{6,}$/.test(n[0]) ? "de " : "") + $.replace("l", "is") : j ? d : $)) : ""));
	}
	return r.join(e);
};

function focusOnmodal(Modal) {
	setTimeout(function () {
		if (typeof Modal._modal != 'undefined') {
			var firstInput = $(Modal._modal).find('input,select,textarea,div[contenteditable=true]').not('.not_tab_enter').filter(":not([readonly]):visible:enabled:first");
		} else {
			var firstInput = $(Modal).find('input,select,textarea,div[contenteditable=true]').not('.not_tab_enter').filter(":not([readonly]):visible:enabled:first");
		}
		firstInput.focus();
	});
}

function KeyboardMobile(KeyBoardClass, Tipo) {
	//'.keyboard-numeric' //'.keyboard-numeric2' //'.keyboard-numeric3'
	if (Tipo == 1) {

		jQuery(KeyBoardClass).keyboard({
			lockInput: true,
			layout: 'num',
			restrictInput: true,
			preventPaste: true,
			autoAccept: true
		});

	} else if (Tipo == 2) {

		jQuery(KeyBoardClass).keyboard({
			lockInput: true,
			layout: 'custom',
			customLayout: {
				'default': [
					'9 . -',
					'6 7 8',
					'3 4 5',
					'0 1 2',
					'{b} {a} {clear}',
					'{panic!!}'
				]
			},
			restrictInput: true,
			preventPaste: true,
			autoAccept: true,
			display: {
				'panic': 'Descrição'
			},
			beforeVisible: function (event, keyboard, el) {
				editAtivo = this;
			}
		});

	} else if (Tipo == 3) {

		jQuery(KeyBoardClass).keyboard({
			lockInput: true,
			layout: 'num',
			/*customLayout: {
				'default' : [
				'9 . -',
				'6 7 8',
				'3 4 5',
				'0 1 2',
				'{b} {a} {clear}',
				'{pani!!}'
				]
			},*/
			restrictInput: true,
			preventPaste: true,
			autoAccept: true,
			display: {
				'pani': 'Descrição'
			},
			beforeVisible: function (event, keyboard, el) {
				editAtivo = this;
			}
		});

	}
}

// Converte um dado tipo File e retorna como Base64 (async)
const asyncToBase64 = file => new Promise((resolve, reject) => {
	const reader = new FileReader();
	reader.readAsDataURL(file);
	reader.onload = () => resolve(reader.result);
	reader.onerror = error => reject(error);
});

// Lê um dado tipo File e retorna como Base64 (async)
async function asyncGetFileBase64(e) {
	const file = document.querySelector('#' + e.target.id).files[0];
	try {
		const result = await asyncToBase64(file);
		return result
	} catch (error) {
		console.error(error);
		return;
	}
	//...
}

function observeIntersection(targetElement, threshold = 0.5) {
	var observer = new IntersectionObserver(onIntersection, {
	  root: null,
	  threshold: threshold
	});
  
	function onIntersection(entries, observer) {
	  entries.forEach(entry => {
		entry.target.classList.toggle('visible', entry.isIntersecting);
	  });
	}
  
	observer.observe(targetElement);
  
	return observer; // Return the observer instance in case you want to unobserve later
}

function switchClass(element, oldClass, newClass) {
    // Get all the classes of the element
    let classes = element.className.split(' ');

    // Find the index of the old class
    let index = classes.indexOf(oldClass);

    // If the old class exists, replace it with the new class
    if (index !== -1) {
        classes[index] = newClass;
    }

    // Join the classes back into a string and set it as the element's class
    element.className = classes.join(' ');
}

function Utils() {

}

Utils.prototype = {
    constructor: Utils,
    isElementInView: function (element, fullyInView) {
        var pageTop = $(window).scrollTop();
        var pageBottom = pageTop + $(window).height();
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).height();

        if (fullyInView === true) {
            return ((pageTop < elementTop) && (pageBottom > elementBottom));
        } else {
            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }
    }
};

function toggleOffcanvas() {

	if (window.location.href != `${urlhost}/home`) {

		var nav_styles = {
			width: "500px",
			height: "calc(100% - 75px)",
			top: "7.25rem"
		}

		$('.offcanvas-nav .nav-container').css(nav_styles);
		$('.offcanvas-nav .nav-container').css(nav_styles);

	} else {

		var nav_styles = {
			width: "500px",
			height: "100%"
		}

		$('.offcanvas-nav .nav-container').css(nav_styles);
		$('.offcanvas-nav .nav-container').css(nav_styles);

	}

	Nav.toggle();

	var param_niver = Number(trim_null($('#_abrir_aniversario').val()));

	if (param_niver == 1) {

		$('.alterarAbrirAniversario').attr('checked', true);

		// $('.alterarAbrirAniversario').css('display','inline-block');
		// $('.alterarAbrirAniversario2').css('display','none');

	} else {

		$('.alterarAbrirAniversario').attr('checked', false);

		// $('.alterarAbrirAniversario').css('display','none');
		// $('.alterarAbrirAniversario2').css('display','inline-block');

	}

}

/**
 * ---------------------------------------------------------------//
 * 						ANIVERSARIANTES FUNCTIONS
 * ---------------------------------------------------------------//
 */

function loadAniversariantes() {

	if (!Nav.isOpen()) {

		executarAniversariantes().then(function (html) {

			aniversariantesHTML = html;

			if(typeof html === 'object'){

				Nav.update({
					pushContent: $('#lista_aniversariantes').html(html.COLABORADORES)
				}, true);

				NavCli.update({
					pushContent: $('#lista_aniversariantes_cliente').html(html.CLIENTES)
				}, true);

			}else{

				Nav.update({
					pushContent: $('#lista_aniversariantes').html(html)
				}, true);

			}

			toggleOffcanvas();

		});

	} else {

		toggleOffcanvas();

	}

}

function loadAniversariantes2() {

	var nav = $('.bday');

	if (!nav.hasClass('show')) {

		executarAniversariantes().then(function (html) {

			aniversariantesHTML = html;

			if(typeof aniversariantesHTML === 'object'){
				if($('#_abrir_aniversario').val() != -1){
					$('#obj_lista_aniversariantes').html(aniversariantesHTML.COLABORADORES);	
				}
				
				if($('#_abrir_aniversario_cliente').val() == 1){
					$('#obj_lista_aniversariantes_clientes').html(aniversariantesHTML.CLIENTES);	
				}
			}else{
				if($('#_abrir_aniversario').val() != -1){
					$('#obj_lista_aniversariantes').html(aniversariantesHTML);	
				}
			}

			toggleBdayPanelJS();

		});

	} else {

		toggleBdayPanelJS();

	}

}

function defineBdayTargetURL(screen_origin){

	var url = trim_null(screen_origin);

	var targetUrl = '/listarAniversarios';

	if(url != ''){

		switch (url) {

			case `${urlhost}/_23540`:
	
				targetUrl = '/listarAniversariosDia';
				
				break;
		
			default:
				break;
	
		}

	}

	return targetUrl;

}

function removerPaineisIFrame(){

	// Get a reference to the iframe
	var iframe = $('#modal-abrir-tela').find('.img-loading-abrir-tela')

	// Wait for the iframe to load
	iframe.onload = function() {
		// Access the iframe's document
		var iframeDocument = iframe.contentWindow.document;

		// Find the element you want to hide (e.g., by its ID)
		var elementToHide = iframeDocument.getElementById('elementToHide');

		// Check if the element exists
		if (elementToHide) {
			// Hide the element (e.g., by setting its style to "display: none;")
			elementToHide.style.display = 'none';
		}
	}

}

function executarAniversariantes(e) {

	var screen_origin = window.location.href;

	var targetUrl = defineBdayTargetURL(screen_origin);

	return new Promise((resolve, reject) => {

		var type = 'POST',
			url = targetUrl,
			data = { 'filtro': '' },
			success = async function (response) {
				var tipo_exibicao 			 = 1;
				var clientes_aniversariantes = [];
				if(typeof response.DADOS_ANIVERSARIANTES != 'undefined'){
					tipo_exibicao 			 = 2;
					clientes_aniversariantes = response.CLIENTES_ANIVERSARIANTES;
					response 				 = response.DADOS_ANIVERSARIANTES;
				}

				$('#periodo_clientes_aniversarios').html('Período de '+moment(moment(moment().startOf('week').toDate()).add('1','days')).format('DD/MM/YYYY')+' a '+moment(moment(moment().endOf('week').toDate()).add('1','days')).format('DD/MM/YYYY'));
				
				if(response.length > 0 || clientes_aniversariantes.length > 0){
					var dias_niver  = [];
					var dias_niver2 = [];
					var menor_data  = new Date();
					var maior_data  = new Date();
					var período		= '';

					for(var index = 0; index < response.length; index++) {
						var element = response[index];
						dias_niver.push({DIA:element.DIA});
					}

					for(var index = 0; index < clientes_aniversariantes.length; index++) {
						var element = clientes_aniversariantes[index];
						dias_niver2.push({DIA:element.DIA,DATA:element.DATA});
					}
	
					dias_niver  = removeDupesInArray(dias_niver,'DIA');		
					dias_niver2 = removeDupesInArray(dias_niver2,'DIA');
	
					for(var index = 0; index < dias_niver.length; index++){
						dias_niver[index].ANIVERSARIANTES = []
						for(var index2 = 0; index2 < response.length; index2++) {
							var element2 = response[index2];
							if(dias_niver[index].DIA == element2.DIA){
								dias_niver[index].ANIVERSARIANTES.push(element2);
							}
						}
					}

					for(var index = 0; index < dias_niver2.length; index++){
						dias_niver2[index].ANIVERSARIANTES = []
						for(var index2 = 0; index2 < clientes_aniversariantes.length; index2++) {
							var element2 = clientes_aniversariantes[index2];
							if(dias_niver2[index].DIA == element2.DIA){
								dias_niver2[index].ANIVERSARIANTES.push(element2);
							}
						}
					}
	
					for(var index = 0; index < dias_niver.length; index++){
						dias_niver[index].ANIVERSARIANTES = sort_by_key(dias_niver[index].ANIVERSARIANTES,'COLABORADOR');
					}
	
					for(var index = 0; index < dias_niver2.length; index++){
						dias_niver2[index].ANIVERSARIANTES = sort_by_key(dias_niver2[index].ANIVERSARIANTES,'CLIENTE');
					}
	
					var html  = '';
					var html2 = '';
	
					for(var index = 0; index < dias_niver.length; index++){
	
						html = html+'<li>';
	
						// Dia
						html += '<div style="font-family: \'Segoe UI\'; font-weight: 600; margin-bottom: 10px;"> DIA '+dias_niver[index].DIA+'</div>';
	
						// Informacoes dos aniversariantes
						for(var index2 = 0; index2 < dias_niver[index].ANIVERSARIANTES.length; index2++) {
	
							var element2 = dias_niver[index].ANIVERSARIANTES[index2];

							// var dataURI = await resizeDataURL(dias_niver[index].ANIVERSARIANTES[index2].FOTO_COLABORADOR, 500, 500);
							var dataURI = dias_niver[index].ANIVERSARIANTES[index2].FOTO_COLABORADOR;

							// var style_img = '';

							/*
							if(dataURI != urlhost + '/assets/images/perfil.png'){
	
								style_img = 'background-image: url('+dataURI+'); background-repeat: no-repeat; background-size: 80px; height: 80px; width: 80px; border-radius: 50%; float: left; margin: 0px 10px 0px 0px; border: 1px solid;';
	
							} else {
	
								style_img = 'background-image: url('+dataURI+'); background-repeat: no-repeat; background-size: 80px; height: 80px; width: 80px; border-radius: 50%; float: left; margin: 0px 10px 0px 0px;';
	
							}
							*/

							// Div container principal - inicio
							html += '<div style="display: flex; flex-direction: row; margin: 0px 0px 10px 0px">';

							// Foto de colaborador
							// html += '<div style="'+style_img+'"></div>'; 
							
							html += '<img src="'+dataURI+'" style="width: 80px; height: 80px; border-radius: 50%; margin: 0px 10px 0px 0px" alt="'+urlhost+'/assets/images/perfil.png">';
	
							// Div container info colaborador - inicio
							html += '<div>';

							// Colaborador
							html += '<div style="font-family: \'Segoe UI\';"> '+dias_niver[index].ANIVERSARIANTES[index2].COLABORADOR+'</div>';

							// Centro de Custo do colaborador
							html += '<div style="font-family: \'Segoe UI\';"> '+(dias_niver[index].ANIVERSARIANTES[index2].CCUSTO2 !== '' ? ''+dias_niver[index].ANIVERSARIANTES[index2].CCUSTO2  : '<br>')+'</div>';
							html += '<div style="font-family: \'Segoe UI\';"> '+(dias_niver[index].ANIVERSARIANTES[index2].CCUSTO3 !== '' ? ''+dias_niver[index].ANIVERSARIANTES[index2].CCUSTO3  : '<br>')+'</div><br>';
	
							// Div container info colaborador - fim
							html += '</div>'

							// Div container principal - fim
							html += '</div>';
	
						}
	
						html = html + '</li>';
						
					}
	
					for(var index = 0; index < dias_niver2.length; index++){
						html2 = html2+'<li>';
						var dia_colorido  = '';
						var dia_colorido2 = '';
						if(moment(dias_niver2[index].DATA,'YYYY-MM-DD').isSame(moment(moment().startOf('day')).toDate())){
							dia_colorido  = 'color: #fdff00 !important;';
							dia_colorido2 = 'id="dia_atual"';
						}
						// Dia
						html2 += '<div '+dia_colorido2+' style="font-family: \'Segoe UI\'; font-weight: 600; margin-bottom: 5px;background-color: rgba(0,0,0,0.5); font-size: 17px;'+dia_colorido+'"> DIA '+dias_niver2[index].DIA+'</div>';
	
						// Informacoes dos aniversariantes
						for(var index2 = 0; index2 < dias_niver2[index].ANIVERSARIANTES.length; index2++) {
	
							var element2 = dias_niver2[index].ANIVERSARIANTES[index2];
							// Cliente
							html2 += '<div style="font-family: \'Segoe UI\';'+dia_colorido+'"> Cliente: '+dias_niver2[index].ANIVERSARIANTES[index2].CLIENTE+'</div>';
							if(trim_null(dias_niver2[index].ANIVERSARIANTES[index2].TELEFONE) != ''){
								html2 += '<div style="font-family: \'Segoe UI\';'+dia_colorido+'"> Telefone: '+dias_niver2[index].ANIVERSARIANTES[index2].TELEFONE+'</div>';
							}

							if(trim_null(dias_niver2[index].ANIVERSARIANTES[index2].DATA_ULT_COMPRA) != '' && trim_null(dias_niver2[index].ANIVERSARIANTES[index2].DATA_ULT_COMPRA) != 'SEM COMPRAS'){
								html2 += '<div style="font-family: \'Segoe UI\';'+dia_colorido+'"> Dt.Últ.Compra: '+trim_null(dias_niver2[index].ANIVERSARIANTES[index2].DATA_ULT_COMPRA)+'</div>';
							}

							if(trim_null(dias_niver2[index].ANIVERSARIANTES[index2].ESTABELECIMENTO) != '' && trim_null(dias_niver2[index].ANIVERSARIANTES[index2].ESTABELECIMENTO) != 'SEM COMPRAS'){
								html2 += '<div style="font-family: \'Segoe UI\';'+dia_colorido+'"> Estabelecimento: '+trim_null(dias_niver2[index].ANIVERSARIANTES[index2].ESTABELECIMENTO)+'</div>';
							}

							if(trim_null(dias_niver2[index].ANIVERSARIANTES[index2].REPRESENTANTE) != ''){
								html2 += '<div style="font-family: \'Segoe UI\';'+dia_colorido+'"> Representante: '+trim_null(dias_niver2[index].ANIVERSARIANTES[index2].REPRESENTANTE)+'</div>';
							}

							if(trim_null(dias_niver2[index].ANIVERSARIANTES[index2].VENDEDOR) != ''){
								html2 += '<div style="font-family: \'Segoe UI\';'+dia_colorido+'"> Vendedor: '+trim_null(dias_niver2[index].ANIVERSARIANTES[index2].VENDEDOR)+'</div>';
							}

							html2 += '<br>';
	
						}
	
						html2 = html2 + '</li>';
						
					}

					var retorno = html;
					if(html2 != ''){
						retorno = {
							COLABORADORES: html,
							CLIENTES: html2
						};
					}
	
					resolve(retorno);

					if(html2 != ''){
						return {
							COLABORADORES: html,
							CLIENTES: html2
						};
					}else{
						return retorno;
					}
					
	
				} else {

					// reject('Não há aniversariantes a serem exibidos!');
					showErro('Não há aniversariantes a serem exibidos!');

				}

			};

		execAjax1(type, url, data,
			function (resposta) {
				success(resposta);
			},
			function (xhr) {
				reject(xhr);
			}
		);

	});

}

/**
 * ---------------------------------------------------------------//
 * ---------------------------------------------------------------//
 * ---------------------------------------------------------------//
 */

// Takes a data URI and returns the Data URI corresponding to the resized image at the wanted size.
function resizeDataURL(dataUri, wantedWidth, wantedHeight) {
	return new Promise(async function (resolve, reject) {

		// We create an image to receive the Data URI
		var img = document.createElement('img');

		// When the event "onload" is triggered we can resize the image.
		img.onload = function () {
			// We create a canvas and get its context.
			var canvas = document.createElement('canvas');
			var ctx = canvas.getContext('2d');

			// We set the dimensions at the wanted size.
			canvas.width = wantedWidth;
			canvas.height = wantedHeight;

			// We resize the image with the canvas method drawImage();
			ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

			var dataURI = canvas.toDataURL();

			// This is the return of the Promise
			resolve(dataURI);
		};

		// We put the Data URI in the image's src attribute
		img.src = dataUri;

	})
} // Use it like : var newDataURI = await resizedataURL('yourDataURIHere', 50, 50);

function mudarStatusAniversario(elemento) {

	var valor = $(elemento).is(':checked') == true ? 1 : 0;

	var type = 'POST',
		url = '/GravarParamAniversario',
		data = { 'VALOR': valor },
		success = function (response) {
			var novo_valor = $(elemento).is(':checked') == true ? 1 : 0;
			showSuccess('Alterações realizadas com sucesso!');
			$('#_abrir_aniversario').val(novo_valor);
		};

	execAjax1(type, url, data,
		function (resposta) {
			success(resposta)
		},
		function (xhr) {
			//reject(xhr);
		});
}

function mudarStatusNotificacao(elemento) {

	var valor = $(elemento).is(':checked') == true ? 1 : 0;

	var type = 'POST',
		url = '/GravarParamNotificacoes',
		data = { 'VALOR': valor },
		success = function (response) {
			var novo_valor = $(elemento).is(':checked') == true ? 1 : 0;
			showSuccess('Alterações realizadas com sucesso!');
			$('#_abrir_notificacoes').val(novo_valor);
		};

	execAjax1(type, url, data,
		function (resposta) {
			success(resposta)
		},
		function (xhr) {
			//reject(xhr);
		});
}

function randomInt(min, max) {
	return min + Math.floor((max - min) * Math.random());
}

/**
 * Format a date string to a given format.
 * @param {Date|string|undefined} date 
 * @param {string} format 
 * @returns string|null
 */
function formatDate(date, format = 'DD.MM.YYYY') {
    if (!date) {
        return null;
    }

    const momentDate = moment(date, format, true);
    return momentDate.isValid() ? momentDate.format(format) : null;
}

function momentFormat(momentInput, momentFormat){
	const fmtMoment = moment(momentInput, momentFormat, true).format(momentFormat);
	return fmtMoment !== 'Invalid date' ? fmtMoment : null;
}

function filterUnique(arr) {
	return arr.filter(
	  (v, i, a) =>
		a.findIndex((v2) => JSON.stringify(v2) === JSON.stringify(v)) === i
	);
}

function parseDateFromString(dateString){
	const formats = [
		'DD/MM/YYYY',
		'MM/DD/YYYY',
		'YYYY/MM/DD',
		'DD-MM-YYYY',
		'MM-DD-YYYY',
		'YYYY-MM-DD'
	];

	let dateObj = null;

	for (const format of formats) {
		const date = moment(dateString, format, true); // Parse string with given format
		if (date.isValid()) {
			dateObj = date.toDate();
			break;
		}
	}

	return dateObj;
}

function parseDateTimeFromString(dateTimeString) {
	const formats = [
	  'DD/MM/YYYY HH:mm:ss',
	  'MM/DD/YYYY HH:mm:ss',
	  'YYYY/MM/DD HH:mm:ss',
	  'DD-MM-YYYY HH:mm:ss',
	  'MM-DD-YYYY HH:mm:ss',
	  'YYYY-MM-DD HH:mm:ss',
	  'DD/MM/YYYY HH:mm',
	  'MM/DD/YYYY HH:mm',
	  'YYYY/MM/DD HH:mm',
	  'DD-MM-YYYY HH:mm',
	  'MM-DD-YYYY HH:mm',
	  'YYYY-MM-DD HH:mm'
	];
  
	let dateTimeObj = null;
  
	for (const format of formats) {
	  const datetime = moment(dateTimeString, format, true); // Parse string with given format
	  if (datetime.isValid()) {
		dateTimeObj = datetime.toDate();
		break;
	  }
	}
  
	return dateTimeObj;
}

function findPropFromObjectsArray(objectsArray, property) {

	if (trim_null(objectsArray) != '') {

		const propertiesArray = objectsArray.map(({ [property]: prop }) => prop);
		return propertiesArray;

	} else {

		return [];

	}

}

function filterByPropValue(arr, prop, value) {
	return arr.filter(item => item[prop] === value);
}

function filterObjectsByPartialValue(array, value) {
	return array.filter(obj => {
		// Check if any property of the object partially matches the given value
		return Object.values(obj).some(propValue => {
			if (typeof propValue === 'string') {
				return propValue.toLowerCase().includes(value.toLowerCase());
			} else if (typeof propValue === 'number') {
				return propValue.toString().includes(value.toString());
			}
			return false;
		});
	});
}

function filterObjectsByProps(arr, propsToKeep) {
	return arr.map(obj => {
	  const filteredObj = {};
	  propsToKeep.forEach(prop => {
		if (obj.hasOwnProperty(prop)) {
		  filteredObj[prop] = obj[prop];
		}
	  });
	  return filteredObj;
	});
}

function removeDupesFromObjArr(array, key) {
	let seen = new Set();
	return array.filter(obj => {
		let value = obj[key];
		if (seen.has(value)) {
			return false;
		} else {
			seen.add(value);
			return true;
		}
	});
}

function removeDupesAndFilter(arr, key, filterFn) {
	const seen = new Set();
	return arr.filter((obj) => {
		if (!obj.hasOwnProperty(key)) return true;
		const val = obj[key];
		if (!seen.has(val) && (!filterFn || filterFn(obj))) {
			seen.add(val);
			return true;
		}
		return false;
	});
}

function removeDupesByKey(array, keys) {
	const unique = [];
	const duplicateValues = new Set();
	array.forEach(obj => {
		const keyValues = keys.map(key => obj[key]);
		if (keyValues.some(value => duplicateValues.has(value))) {
			// If one of the key values is already a duplicate, skip this object
			return;
		}
		const isDuplicate = unique.some(otherObj => {
			return keys.every(key => obj[key] === otherObj[key]);
		});
		if (isDuplicate) {
			// Add all the key values to the duplicate set
			keyValues.forEach(value => duplicateValues.add(value));
		} else {
			unique.push(obj);
		}
	});
	return unique;
}

function hasPropertyValue(objects, property, value) {
	return objects.some(obj => obj[property] === value);
}

function stringifyArrayWithoutBrackets(array) {

	if (trim_null(array) != '') {

		const stringifiedArray = array.join(', ');
		return stringifiedArray;

	} else {

		return '';

	}

}

function numberToRoundedFloat(num) {

	var formatNum = parseFloat(num);
	var roundedNum = Math.round((formatNum + Number.EPSILON) * 100) / 100;

	return roundedNum;

}

function toggleNotificationsPanelJS() {

	var sidebar = $('#sidebar');

	sidebar.toggleClass('show');

}

function toggleBdayPanelJS(class_niver) {

	if(typeof class_niver == 'undefined'){
		var sidebar = $('.bday');
	}else{
		var sidebar = $('.bday'+class_niver);
	}

	var param_niver = Number(trim_null($('#_abrir_aniversario').val()));

	if (param_niver == 1) {

		$('.alterarAbrirAniversario').attr('checked', true);

		// $('.alterarAbrirAniversario').css('display','inline-block');
		// $('.alterarAbrirAniversario2').css('display','none');

	} else {

		$('.alterarAbrirAniversario').attr('checked', false);

		// $('.alterarAbrirAniversario').css('display','none');
		// $('.alterarAbrirAniversario2').css('display','inline-block');

	}

	//if(sidebar.length > 1){
		for(var index = 0; index < sidebar.length; index++) {
			var element = sidebar[index];
			var abrir   = true;
			if($(element).hasClass('clientes')){
				var lista_clientes = $(element).find('ul#obj_lista_aniversariantes_clientes').first().html();
				if(trim_null(lista_clientes)    == '' || $('#_abrir_aniversario_cliente').val() == 0){
					abrir   = false;
				}
			}

			if($(element).hasClass('colaboradores')){				
				var lista_colaborador = $(element).find('ul#obj_lista_aniversariantes').first().html();
				if(trim_null(lista_colaborador) == '' || $('#_abrir_aniversario').val() < 0){
					abrir   = false;
				}
			}

			if(abrir){
				if($(element).hasClass('clientes')){
					if($('.bday.notifications-panel.colaboradores').first().hasClass('show')){
						$('.bday.notifications-panel.clientes').first().css('right','500px');
					}else{
						$('.bday.notifications-panel.clientes').first().css('right','');
					}
				}

				if($(element).hasClass('colaboradores')){
					if($('.bday.notifications-panel.clientes').first().hasClass('show')){
						$('.bday.notifications-panel.colaboradores').first().css('right','500px');
					}else{
						$('.bday.notifications-panel.colaboradores').first().css('right','');
					}
				}

				$(element).toggleClass('show');	

				if($(element).hasClass('colaboradores') && $('.bday.notifications-panel.colaboradores').first().hasClass('show') == false){

					if($('.bday.notifications-panel.clientes').first().hasClass('show')){
						$('.bday.notifications-panel.clientes').first().css('right','');
					}
				}

				if($(element).hasClass('clientes') && $('.bday.notifications-panel.clientes').first().hasClass('show') == true){
					var a = document.getElementById('dia_atual');
					$('#obj_lista_aniversariantes_clientes').parent().parent().parent().parent().parent().scrollTop(0);
					if(a !== null){
						$('#obj_lista_aniversariantes_clientes').parent().parent().parent().parent().parent().scrollTop($('#dia_atual').parent().get(0).getBoundingClientRect().top-$('#obj_lista_aniversariantes_clientes').get(0).getBoundingClientRect().top);
					}
				}
			}			
		}
	/*}else{
		sidebar.toggleClass('show');
	}*/

}

function checkCookieExists(cookieName) {
	var cookies = document.cookie.split(';');
	for (var i = 0; i < cookies.length; i++) {
		var cookie = cookies[i].trim();
		if (cookie.startsWith(cookieName + '=')) {
		return true;
		}
	}
	return false;
}

function renderBlobHTML(elementId) {
	// Get the HTML content
	var htmlContent = document.getElementById(elementId).innerHTML;

	// Create a Blob with the HTML content
	var blob = new Blob([htmlContent], { type: "text/html" });

	// Generate a Blob URL for the Blob object
	var blobUrl = URL.createObjectURL(blob);

	// Return the Blob URL
	return blobUrl;
}

function bootstrapInit() {

}

function ativarBtnSwitch() {
	//console.log('switch ativado');
	if ($('.chk-switch').length > 0) {

		$('.chk-switch')
			.bootstrapSwitch();
	}
}

function deleteCookie(cookieName) {
	document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

function encurtarURL(url, personalizado = '') {

	return new Promise((resolve, reject) => {

		if(trim_null(url) != ''){

			var dados = {
				url		: trim_null(url),
				format	: "json"
			};

			if(trim_null(personalizado) != ''){
				dados.shorturl = trim_null(personalizado);
			}

			$.getJSON("https://is.gd/create.php?callback=?", dados)
				.done(function(response) {

					if(typeof response.errorcode != "undefined" && response.errorcode > 0){

						console.log('------------------------------------------------------------------------');
						console.log('Erro ao encurtar link do catálogo...');
						console.log(response);
						console.log('------------------------------------------------------------------------');

						reject(response);
					}else{
						resolve(response.shorturl);

						return response.shorturl;
					}
				})
				.fail(function(e) {

					console.log('------------------------------------------------------------------------');
					console.log('Erro ao encurtar link do catálogo...');
					console.log(e);
					console.log('------------------------------------------------------------------------');

					reject(e);
				})
			;

		}else{
			reject({});
		}

	});

}

window.isMobileDevice = function() {
	let check = false;

	(function(a){
		if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;
	})(navigator.userAgent||navigator.vendor||window.opera);
	
	return check;
};

function openBase64PDF(base64PDF) {
	// Decode base64 string
	const binaryString = atob(base64PDF);

	// Create binary array
	const binaryLen = binaryString.length;
	const binaryArray = new Uint8Array(binaryLen);
	for (let i = 0; i < binaryLen; i++) {
	   binaryArray[i] = binaryString.charCodeAt(i);
	}

	// Create a blob from the binary array
	const blob = new Blob([binaryArray], {type: "application/pdf"});
	
	// Create an object URL from the blob
	const blobUrl = URL.createObjectURL(blob);

	// Open the PDF in a new tab
	window.open(blobUrl, '_blank');
}

function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            // Remove the data URL prefix and only keep the base64 content
            const base64String = reader.result.split('base64,')[1];
            resolve(base64String);
        };
        reader.onerror = error => reject(error);
        reader.readAsDataURL(file);
    });
}

function base64ToBlobUrl(base64Content, mimeType) {
    // Ensure mimeType is defined or default to empty string
    mimeType = mimeType || '';

    // Check if the content is a data URL
    const isDataUrl = base64Content.startsWith('data:');

    // If it's a data URL, extract the Base64 content part
    if (isDataUrl) {
        // Find the index of the base64 encoding part in the data URL
        const base64Index = base64Content.indexOf(';base64,');
        if (base64Index !== -1) {
            // Remove data URL prefix to get just the Base64 content
            base64Content = base64Content.substr(base64Index + 8);
        }
    }

    // Convert Base64 to ArrayBuffer
    const byteCharacters = atob(base64Content); // Decode Base64
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i); // Convert characters to byte numbers
    }
    const byteArray = new Uint8Array(byteNumbers); // Create Uint8Array from byte numbers
    const blob = new Blob([byteArray], { type: mimeType }); // Create Blob from Uint8Array and mimeType

    // Create a Blob URL from the Blob object
    const blobUrl = URL.createObjectURL(blob); // Create a URL for the Blob object
    
    // Return the Blob URL
    return blobUrl;
}

/**
 * Converts a DataURL to a Blob URL.
 * @param {string} dataURL - The DataURL to convert.
 * @returns {string} - The Blob URL.
 */
function dataURLToBlobURL(dataURL) {
    // Extract the MIME type and data part from the DataURL
    const [header, data] = dataURL.split(',');
    const mime = header.match(/:(.*?);/)[1];

    // Decode the base64 data
    const binary = atob(data);
    const arrayBuffer = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        arrayBuffer[i] = binary.charCodeAt(i);
    }

    // Create a Blob from the binary data
    const blob = new Blob([arrayBuffer], { type: mime });

    // Generate and return a Blob URL
    return URL.createObjectURL(blob);
}

/**
 * Converts a decimal color value to its hexadecimal representation.
 *
 * @param {number|string} decimal - The decimal color value to convert.
 * @returns {string|boolean} The hexadecimal color code if valid, or false otherwise.
 */
function decimalToHexColor(decimal) {
	// Convert the input to a string and trim whitespace.
	const trimmed = String(decimal).trim();

	if (trimmed === '') return false;

	// Remove any '$' sign if present in the input.
	const cleaned = trimmed.replace(/\$/g, '');

	// Convert the cleaned value to a number.
	const num = Number(cleaned);
	if (isNaN(num) || num < 0 || num > 16777215) return false;

	// Extract the RGB components from the number.
	const r = num & 0xFF;
	const g = (num >> 8) & 0xFF;
	const b = (num >> 16) & 0xFF;

	// Convert the RGB components to hexadecimal and ensure two digits.
	const rHex = r.toString(16).padStart(2, '0');
	const gHex = g.toString(16).padStart(2, '0');
	const bHex = b.toString(16).padStart(2, '0');

	// Return the concatenated hexadecimal color string.
	return `#${rHex}${gHex}${bHex}`;
}

/**
 * This function takes a value and converts it into a slug. A slug is a string where all characters are in lower case,
 * special characters and spaces are replaced with a specified separator, and consecutive separators are merged into one.
 * Accented characters are replaced with their non-accented counterparts.
 * 
 * @param {any} value - The value to be converted into a slug.
 * @param {string} separator - The separator to use in the slug. Default is a hyphen.
 * @returns {string} - The resulting slug.
 */
function slugify(value, separator = '-') {
    // Convert the value to a string.
    let string = String(value);

    // This object maps accented characters to their non-accented counterparts.
    const charMap = {
        'á': 'a', 'à': 'a', 'ã': 'a', 'â': 'a', 'ä': 'a',
        'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e',
        'í': 'i', 'ì': 'i', 'î': 'i', 'ï': 'i',
        'ó': 'o', 'ò': 'o', 'õ': 'o', 'ô': 'o', 'ö': 'o',
        'ú': 'u', 'ù': 'u', 'û': 'u', 'ü': 'u',
        'ñ': 'n', 'ç': 'c',
        'Á': 'A', 'À': 'A', 'Ã': 'A', 'Â': 'A', 'Ä': 'A',
        'É': 'E', 'È': 'E', 'Ê': 'E', 'Ë': 'E',
        'Í': 'I', 'Ì': 'I', 'Î': 'I', 'Ï': 'I',
        'Ó': 'O', 'Ò': 'O', 'Õ': 'O', 'Ô': 'O', 'Ö': 'O',
        'Ú': 'U', 'Ù': 'U', 'Û': 'U', 'Ü': 'U',
        'Ñ': 'N', 'Ç': 'C'
    };

    // Replace each accented character in the string with its non-accented counterpart.
    string = string.split('').map(char => charMap[char] || char).join('');

    // Convert the string to lower case.
    string = string.toLowerCase();

    // Replace all characters that are not alphanumeric with the specified separator.
    string = string.replace(/[^a-z0-9]/gi, separator);

    // Replace consecutive separators with a single separator.
    const separatorRegex = new RegExp(`${separator}+`, 'g');
    string = string.replace(separatorRegex, separator);

    // Remove leading and trailing separators.
    const trimRegex = new RegExp(`^${separator}|${separator}$`, 'g');
    string = string.replace(trimRegex, '');

    // Return the resulting slug.
    return string;
}

/**
 * #####################################################################################################################################################
 * JQUERY
 * #####################################################################################################################################################
 */

(function ($) {
	$(function () {
		//console.log('função chamada');

		getTimeZone();

		$('body')
			.on('mouseenter', '[data-toggle="popover"]', function () {

				$(this)
					.popover({
						html: true,
						container: 'body',
						content: function () {
							var elem = $(this).attr('data-element-content');
							return $(elem).html();
						},
						trigger: 'manual'
					});

				var old_popover = $(this).attr('aria-describedby');

				if (old_popover == undefined) {

					$(this).popover("show");
					var popover_show_id = $(this).attr('aria-describedby');

					$('body').children('.popover').each(function () {
						if ($(this).attr('id') != popover_show_id) {
							$(this).popover('hide');
						}
					});
				}

				$(this)
					.on('show.bs.tooltip', function () {
						$(document).not(this).on('mouseenter', function (event) {
							$('.tooltip').remove();
							$(document).not(this).off('mouseenter');
							event.stopPropagation();
							event.stopImmediatePropagation();
							event.preventDefault();
							console.log('event prevented and tooltips removed');
						});
					});
			})
			.on('mouseleave', '[data-toggle="popover"]', function () {
				var _this = this;

				setTimeout(function () {

					if ((!$(".popover:hover").length) && (!$(_this).is(":hover"))) {
						$(".popover").popover("hide");
					}

					$('[id="' + $(_this).attr('aria-describedby') + '"]').on("mouseleave", function () {
						if ((!$(".popover:hover").length) && (!$(_this).is(":hover"))) {
							$(this).popover("hide");
						}
					});

				}, 100);
			})
			.on('mouseenter', '[data-toggle="tooltip"]', function () {

				$('.tooltip').remove();

				$(this)
					.attr('data-base-title', $(this).attr('title'))
					.attr('data-original-title', $(this).attr('title'))
					.removeAttr('title')
					.tooltip({
						trigger: 'hover',
						container: "body",
						html: true
					})
					.tooltip('show')
					;

				$(this)
					.on('hidden.bs.tooltip', function () {
						$(this)
							.attr('title', $(this).attr('data-base-title'))
							.removeAttr('data-base-title')
							.removeAttr('data-original-title')
							;
					});

				$(this)
					.on('show.bs.tooltip', function () {
						$(document).not(this).on('mouseenter', function (event) {
							$('.tooltip').remove();
							$(document).not(this).off('mouseenter');
							event.stopPropagation();
							event.stopImmediatePropagation();
							event.preventDefault();
							console.log('event prevented and tooltips removed');
						});
					});

				$(this)
					.on('shown.bs.tooltip', function () {
						$(document).not(this).on('mouseenter', function (event) {
							$('.tooltip').remove();
							$(document).not(this).off('mouseenter');
							event.stopPropagation();
							event.stopImmediatePropagation();
							event.preventDefault();
							console.log('event prevented and tooltips removed');
						});
					});
			})
			;
		/*
		$(document)
		.on('click', '.go-favorito-1, .go-favorito-2', function (event) {

			var tipo_gravar_menu123 = 0;
			if(typeof $(this).attr('menu-id') != undefined){
				var menu_id  = $(this).attr('menu-id');
				if($(this).hasClass('go-favorito-1')){
					tipo_gravar_menu123 = 1;
				}else{
					tipo_gravar_menu123 = 2;
				}

				var objeto = {
					MENU: $(this).attr('menu-id'),
					TIPO: tipo_gravar_menu123
				}

				var tipo_menu = 1;
				if($(this).attr('menu-id') >= 28000){
					tipo_menu = 2;
				}
				
				var type	= "POST",
					url		= "/adicionarFavoritos",
					data	= {
						'MENU': "'CONTROLE'=>"+$(this).attr('menu-id')+",'TIPO'=> "+tipo_menu+"", 
						'TIPO': tipo_gravar_menu123
					},
					success	= function(data) {
						var text 	 = '';
						var favorito = '';						
						if(tipo_gravar_menu123 == 1){							
							text = 'Favorito adicionado com sucesso!<br>';
							$('.go-favorito-2').css('display','');
							$('.go-favorito-1').css('display','none');
							favorito = 1;
						}else{
							$('.go-favorito-2').css('display','none');
							$('.go-favorito-1').css('display','');							
							text = 'Favorito removido com sucesso!<br>';
							favorito = 0;
						}
						var jota_som = localStorage.getItem('ngStorage-menus');
						var achado = false;
						if(typeof jota_som == 'string'){
							jota_som = JSON.parse(jota_som);							
							for(var index = 0; index < jota_som.length; index++) {
								if(jota_som[index].CONTROLE == menu_id){
									jota_som[index].FAVORITO = favorito;
									achado = true;
									break;
								}								
							}
						}

						if(achado){
							jota_som = JSON.stringify(jota_som);
							localStorage.setItem('ngStorage-menus',jota_som);
						}

						showSuccess(text);
					}

				execAjax3(type, url, data, success, null, false);

			}
		}) 
		*/
		$(document)
			.on('mouseenter', '.tooltip-field, .limit-width, [auto-title], [data-auto-title], [autotitle], [data-autotitle]', function () {

				$('.tooltip').remove();
				var offsetWidth = this.offsetWidth;
				var scrollWidth = this.scrollWidth;

				if (offsetWidth < scrollWidth) {
					$(this)
						.attr('data-toggle', 'tooltip')
						.attr('data-base-title', $(this).text())
						.attr('data-original-title', $(this).text())
						.tooltip({
							trigger: 'hover',
							container: "body",
							html: true
						})
						.tooltip('show')
						;

					$(this)
						.on('hidden.bs.tooltip', function () {
							$(this)
								.removeAttr('title')
								.removeAttr('data-base-title')
								.removeAttr('data-original-title')
								;
						});
				}
				else {
					$(this)
						.removeAttr('data-toggle')
						.removeAttr('title')
						.removeAttr('data-original-title')
						.removeAttr('data-base-title')
						.tooltip('hide')
						;
				}
			})
			.on('mouseenter focus', '[atitle]', function () {
				var that = this;
				$('.tooltip').remove();
				setTimeout(function () {

					$(that)
						.attr('data-toggle', 'tooltip')
						.attr('data-base-title', $(that).attr('atitle'))
						.attr('data-original-title', $(that).attr('atitle'))
						.tooltip({
							trigger: 'hover',
							container: "body",
							html: true
						})
						.tooltip('show')
						;

					$(that)
						.on('hidden.bs.tooltip', function () {
							$(that)
								.removeAttr('title')
								.removeAttr('data-base-title')
								.removeAttr('data-original-title')
								;
						});
				});

			})
			.on('mouseenter', '[atitle]', function () {

				$('.tooltip').remove();

				$(this)
					.attr('data-toggle', 'tooltip')
					.attr('data-base-title', $(this).attr('atitle'))
					.attr('data-original-title', $(this).attr('atitle'))
					.tooltip({
						trigger: 'hover',
						container: "body",
						html: true
					})
					.tooltip('show')
					;

				$(this)
					.on('hidden.bs.tooltip', function () {
						$(this)
							.removeAttr('title')
							.removeAttr('data-base-title')
							.removeAttr('data-original-title')
							;
					});

			})
			.on('mouseleave', '[atitle], [t-title], [data-toggle="tooltip"], [bs-title], .tooltip-field, .limit-width, [auto-title], [data-auto-title], [autotitle], [data-autotitle]', function () {
				$('.tooltip').remove();
			});

		$(document)
			.on('mouseenter', '.tooltip-field, .limit-width, [auto-title], [data-auto-title], [autotitle], [data-autotitle]', function () {

				$('.tooltip').remove();
				var offsetWidth = this.offsetWidth;
				var scrollWidth = this.scrollWidth;

				if (offsetWidth < scrollWidth) {
					$(this)
						.attr('data-toggle', 'tooltip')
						.attr('data-base-title', $(this).text())
						.attr('data-original-title', $(this).text())
						.tooltip({
							trigger: 'hover',
							container: "body",
							html: true
						})
						.tooltip('show')
						;

					$(this)
						.on('hidden.bs.tooltip', function () {
							$(this)
								.removeAttr('title')
								.removeAttr('data-base-title')
								.removeAttr('data-original-title')
								;
						});
				}
				else {
					$(this)
						.removeAttr('data-toggle')
						.removeAttr('title')
						.removeAttr('data-original-title')
						.removeAttr('data-base-title')
						.tooltip('hide')
						;
				}
			})
			.on('mouseenter focus', '[btitle]', function () {
				var that = this;
				$('.tooltip').remove();
				setTimeout(function () {

					$(that)
						.attr('data-toggle', 'tooltip')
						.attr('data-base-title', $(that).attr('btitle'))
						.attr('data-original-title', $(that).attr('btitle'))
						.tooltip({
							trigger: 'hover',
							container: "body",
							html: true
						})
						.tooltip('show')
						;

					$(that)
						.on('hidden.bs.tooltip', function () {
							$(that)
								.removeAttr('title')
								.removeAttr('data-base-title')
								.removeAttr('data-original-title')
								;
						});
				});

			})
			.on('mouseenter', '[btitle]', function () {

				$('.tooltip').remove();

				$(this)
					.attr('data-toggle', 'tooltip')
					.attr('data-base-title', $(this).attr('btitle'))
					.attr('data-original-title', $(this).attr('btitle'))
					.tooltip({
						trigger: 'hover',
						container: "body",
						html: true
					})
					.tooltip('show')
					;

				$(this)
					.on('hidden.bs.tooltip', function () {
						$(this)
							.removeAttr('title')
							.removeAttr('data-base-title')
							.removeAttr('data-original-title')
							;
					});

			})
			.on('mouseleave', '[btitle], [t-title], [data-toggle="tooltip"], [bs-title], .tooltip-field, .limit-width, [auto-title], [data-auto-title], [autotitle], [data-autotitle]', function () {
				$('.tooltip').remove();
			});

		bootstrapInit();
		//bootstrapInit();
		ativarBtnSwitch();

	});

	$(document).on("mouseover", '#div-user-login-click', function () {
		var original = $('#div-user-login-click').attr('original-title');

		$('#div-user-login-click').attr('title', original + ', Download: ' + navigator.connection.downlink + 'M/s, Ping: ' + navigator.connection.rtt + 'ms');
	});

	// $(document).on("click",'#div-user-login-click', function(){
	// 	$('#modal-user-login').modal('show');
	// });

	$(document).on("click", '#test-internet-speed', function () {
		$('#modal-user-login').modal('show');
	});

	$(document).on("click", '#div-user-login-fechar', function () {
		$('#modal-user-login').modal('hide');
	});

	$(document).on("mouseenter", '.navbar', function () {
		$('.tooltip').remove();
	});

	// ////////////////////////////////////////////////////////////////////////////////////////////////

	// Abre o modal de alterar senha de usuario
	$(document).on("click", "#usuario-alter-pass", function () {

		$('#modal-alterar-senha').modal('show');
		$('#exibir-modal-alterar-senha').addClass('modal-ativado');

	});
	
	$(document).on("click", "#qrcode-acesso", function () {

		var type	= 'GET',
			url		= '/_11300/gerarQRCode',
			data	= {'filtro': ''},
			success	= function(data) {
				$('#modal-qrcode').modal('show');
				$('#exibir-modal-qrcode').addClass('modal-ativado');

				$('#qrcodeImage').css('background-image', 'url('+data+')');
				$('.download-qrcode').attr("href", data);


				$('#apple_store').attr("href", 'https://apps.apple.com/br/app/1626341653');
				$('#play_store').attr("href", 'https://play.google.com/store/apps/details?id=com.kayros.gcweb');


				$('#app-download').text('GCWeb APP');
				$('#title-modal-qrcode').text('GCWeb App - QRCODE');
			};

		execAjax2(type, url, data, success);

	});

	$(document).on("click", "#qrcode-rep-acesso", function () {

		let permissao	 = $('#rep_permissao_usuario').val();
		let value_access = $('#rep_gcwebponto').val();
			value_access = JSON.parse(value_access);

		var url		= 'https://rep.gcweb.app.br/qrCode_access?id='+ value_access.CLIENT_ID +'&secret='+ value_access.CLIENT_SECRET;


		if (permissao == 1) {
			$('#modal-qrcode').modal('show');
			$('#exibir-modal-qrcode').addClass('modal-ativado');

			$('#qrcodeImage').css('background-image', 'url('+ url +')');
			$('.download-qrcode').attr("href", url);


			$('#apple_store').attr("href", 'https://apps.apple.com/br/app/6743763129');
			$('#play_store').attr("href", 'https://play.google.com/store/apps/details?id=com.kayros.gcwebrep2');


			$('#app-download').text('GCWeb Ponto');
			$('#title-modal-qrcode').text('GCWeb Ponto - QRCODE');
		} else {
			showAlert('Você não tem permissão utilizar as credenciais de acesso do GCWeb Ponto');
		}

	});

	// Fecha o modal de alterar senha de usuario
	$(document).on("click", "#btn-fechar-modal-senha", function () {

		$('#modal-alterar-senha').modal('hide');
		$('#exibir-modal-alterar-senha').removeClass('modal-ativado');

	});

	$(document).on("click", "#btn-fechar-modal-qrcode", function () {

		$('#modal-qrcode').modal('hide');
		$('#exibir-modal-qrcode').removeClass('modal-ativado');

	});

	// Abre o modal de alterar senha de usuario
	$(document).on("click", "#colaborador-alter-pass", function () {

		$('#modal-alterar-senha-colab').modal('show');
		$('#exibir-modal-alterar-senha-colab').addClass('modal-ativado');

	});

	// Fecha o modal de alterar senha de usuario
	$(document).on("click", "#btn-fechar-modal-senha-colab", function () {

		$('#modal-alterar-senha-colab').modal('hide');
		$('#exibir-modal-alterar-senha-colab').removeClass('modal-ativado');

	});

	// Função para visualizar senhas do modal Alterar Senha de Usuário
	$(document).on("click", "#show_passwords", function () {

		var fields = document.getElementById('form-change-password').elements;

		for (let i = 0; i < fields.length - 1; i++) {

			if (fields[i].type === "password") {

				fields[i].type = "text";

			} else {

				fields[i].type = "password";

			}

		}

	});

	// Função para visualizar senhas do modal Alterar Senha de Usuário
	$(document).on("click", "#show_passwords_colab", function () {

		var fields = document.getElementById('form-change-password-colab').elements;

		for (let i = 0; i < fields.length - 1; i++) {

			if (fields[i].type === "password") {

				fields[i].type = "text";

			} else {

				fields[i].type = "password";

			}

		}

	});

	// Realiza o post de alteração de senha (usuário)
	$(document).on("click", "#btn-post-password-js2", function () {

		var old_password = trim_null($('#old_password_colab').val());
		var new_password = trim_null($('#new_password_colab').val());
		var confirm_new_pass = trim_null($('#confirm_new_password_colab').val());

		if (old_password != "" && new_password != "" && confirm_new_pass != "") {

			if (new_password === confirm_new_pass) {

				var colaborador_id = $('#colaborador-id').val();

				var dados = {
					SENHA_ANTIGA: old_password,
					NOVA_SENHA: new_password,
					// CONFIRMA_NOVA_SENHA:	confirm_new_pass
					COLABORADOR_ID: trim_null(colaborador_id) != '' ? Number(colaborador_id) : 0
				}

				var ajaxType = 'POST',
					ajaxUrl = '/_23540/api/postAlterarSenhaColab',
					ajaxData = dados;

				execAjax1(ajaxType, ajaxUrl, ajaxData, ajaxSuccess, false);

				function ajaxSuccess() {
					$('#modal-alterar-senha').modal('hide');
					window.location.replace(urlhost + '/portal-colaborador/logout');
				}

			} else {

				$('#password_err').css('display', 'block');
				$('#confirm_password_err').css('display', 'block');

			}

		} else {

			showErro('Preencha todos os campos para alterar sua senha.');

		}

	});

	// Realiza o post de alteração de senha (colaborador)
	$(document).on("click", "#btn-post-password-js", function () {

		var old_password = trim_null($('#old_password').val());
		var new_password = trim_null($('#new_password').val());
		var confirm_new_pass = trim_null($('#confirm_new_password').val());

		if (old_password != "" && new_password != "" && confirm_new_pass != "") {

			if (new_password === confirm_new_pass) {

				var dados = {
					SENHA_ANTIGA: old_password,
					NOVA_SENHA: new_password,
					// CONFIRMA_NOVA_SENHA:	confirm_new_pass
				}

				var ajaxType = 'POST',
					ajaxUrl = '/_11300/api/postAlterarSenhaUsuario',
					ajaxData = dados;

				execAjax1(ajaxType, ajaxUrl, ajaxData, ajaxSuccess, false);

				function ajaxSuccess() {
					$('#modal-alterar-senha-colab').modal('hide');
					window.location.replace(urlhost + '/auth/logout');
				}

			} else {

				$('#password_err').css('display', 'block');
				$('#confirm_password_err').css('display', 'block');

			}

		} else {

			showErro('Preencha todos os campos para alterar sua senha.');

		}

	});

	$(document).on('click', '#go-notif-btn1', function () {
		toggleNotificationsPanelJS();
	});

	$(document).on('click', '#go-notif-btn2', function () {
		toggleNotificationsPanelJS();
	});

	$(document).on('click', '#go-notif-menu-btn1', function () {
		toggleNotificationsPanelJS();
	});

	$(document).on('click', '#go-notif-menu-btn2', function () {
		toggleNotificationsPanelJS();
	});

	$(document).on('click', '#close-notifications', function () {
		toggleNotificationsPanelJS();
	});

	$(document).on('click', '#close-bday', function () {
		toggleBdayPanelJS('.colaboradores');
	});

	$(document).on('click', '#close-bday2', function () {
		toggleBdayPanelJS('.clientes');
	});


	$(document).on('mouseenter', '.logo-watermark', function () {

		var wm = $('.logo-watermark');

		if (wm.css('left') == '5px') {

			wm.css({
				'left': 'auto',
				'right': '5px'
			});

		} else {

			wm.css({
				'left': '5px',
				'right': 'auto'
			});

		}

	});

	$(document).on('mouseenter', '.menu-logo-watermark', function () {

		var wm = $('.menu-logo-watermark');

		if (wm.css('left') == '5px') {

			wm.css({
				'left': 'auto',
				'right': '5px'
			});

		} else {

			wm.css({
				'left': '5px',
				'right': 'auto'
			});

		}

	});

	$(document).ready(() => {

		if (window.location.href == urlhost + '/home') {

			$('.menu-logo-watermark').show();
			$('.logo-watermark').hide();

		} else {

			$('.menu-logo-watermark').hide();
			$('.logo-watermark').show();

		}

	})

	// Toggling the Sidebar
	$(document).on('click', '#navbar-toggle-offcanvas', () => {

		const sidebar = $('#__offcanvas');

		const mainApp = $('#main');
		const mainSlides = $('.slide-img');

		sidebar.toggleClass('show');

		if (window.location.href !== urlhost + '/_23540') {

			mainApp.toggleClass('push-content');

		} else if (window.innerWidth > 1023 ){

			mainSlides.toggleClass('push-content');

		} else {

			mainSlides.removeClass('push-content');

		}

	});

	$(document).on('click', '#__offcanvas_close', () => {

		const sidebar = $('#__offcanvas');

		const mainApp = $('#main');
		const mainSlides = $('.slide-img');

		sidebar.toggleClass('show');

		if (window.location.href !== urlhost + '/_23540') {

			mainApp.toggleClass('push-content');

		} else {

			mainSlides.toggleClass('push-content');

		}

	});

	$(document).keyup(function (e) {
		if (e.key == 'Escape') {
			var sidebar = $('#sidebar');
			sidebar.removeClass('show');
		}
	});

	$(document).on('click', '.btn-trigger-menus', function () {

		$('#btn-filtro-menu').trigger('click');

	})

	$(document).ready(function(){

		var cookieShowOnceExists = checkCookieExists('SHOW_ONCE');
		var cookieNotif    		 = getCookieJS('TIPO_NOTIFICACAO');
	
		if(cookieShowOnceExists && cookieNotif == '2'){
	
			deleteCookie('SHOW_ONCE');
			// window.location.reload(true);
	
		}
	
	})

	/*
	$(document).on('click', '.portal-colaborador-btn', function(){
		return new Promise((resolve, reject) => {
			const url = `${urlhost}/api/_23540/logarComoAdmin`;

			execAjax1(
				'POST',
				url,
				{},
				(response) => {
					if(response.success){
						resolve(response);
					}else{
						reject(response);
					}
				},
			)
		});
	})	
	*/

	function getFileSizeFromBase64(base64Content) {
		// Remove data URI prefix if present
		const base64Data = base64Content.replace(/^data:.*;base64,/, '');
	  
		// Decode Base64 to binary data
		const binaryData = atob(base64Data);
	  
		// Calculate the size in bytes
		const fileSizeInBytes = binaryData.length;
	  
		// Convert to human-readable format (e.g., KB, MB, GB) for better representation
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
		const i = Math.floor(Math.log(fileSizeInBytes) / Math.log(1024));
		const fileSizeHumanReadable = (fileSizeInBytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
	  
		return {
		  bytes: fileSizeInBytes,
		  humanReadable: fileSizeHumanReadable,
		};
	}	

	// jQuery Extensions

	jQuery.fn.extend({
        prependClass: function(newClasses) {
            return this.each(function() {
                var currentClasses = $(this).prop("class");
                $(this).removeClass(currentClasses).addClass(newClasses + " " + currentClasses);
            });
        }
    });

})(jQuery);